<template>
  <div data-elementor-type="page" data-elementor-id="1534" class="elementor elementor-1534" data-elementor-post-type="elementor_library">
    <div class="has_eae_slider elementor-element elementor-element-ed7ec6d e-con-full e-flex e-con e-parent e-lazyloaded" data-id="ed7ec6d" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
      <div
        class="custom-background has_eae_slider elementor-element elementor-element-696b814 e-con-full static e-flex e-con e-child"
        data-id="696b814"
        data-element_type="container"
        data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
        :style="backgroundStyle"
      ></div>
      <div class="has_eae_slider elementor-element elementor-element-578a777 e-con-full main e-flex e-con e-child" data-id="578a777" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
        <div
          class="custom-background has_eae_slider elementor-element elementor-element-ebf98ba e-con-full e-flex e-con e-child"
          data-id="ebf98ba"
          data-element_type="container"
          id="cover"
          data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
          :style="backgroundStyle"
        >
          <div
            class="has_eae_slider elementor-element elementor-element-b2d1051 e-con-full e-flex e-con e-child"
            data-dce-background-overlay-color="#000000"
            data-id="b2d1051"
            data-element_type="container"
            data-settings='{"jet_parallax_layout_list":[]}'
          >
            <div class="has_eae_slider elementor-element elementor-element-2e8c949 e-con-full e-flex e-con e-child" data-id="2e8c949" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div
                class="elementor-element elementor-element-cc8b6b7 animated-slow elementor-widget elementor-widget-heading animated zoomIn"
                data-id="cc8b6b7"
                data-element_type="widget"
                data-settings='{"_animation":"zoomIn","_animation_delay":1000}'
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">The Wedding Of</h2>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-a6b6f60 animated-slow elementor-widget elementor-widget-heading animated zoomIn"
                data-id="a6b6f60"
                data-element_type="widget"
                data-settings='{"_animation":"zoomIn","_animation_delay":1100}'
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ pasangan }}</h2>
                </div>
              </div>
            </div>
            <div class="has_eae_slider elementor-element elementor-element-cd64273 e-con-full e-flex e-con e-child" data-id="cd64273" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div
                class="elementor-element elementor-element-8fd9ee3 animated-slow elementor-widget elementor-widget-heading animated fadeInUp"
                data-id="8fd9ee3"
                data-element_type="widget"
                data-settings='{"_animation":"fadeInUp","_animation_delay":1500}'
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">Kepada Yth:</h2>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-d53beb9 namatamu animated-slow elementor-widget elementor-widget-heading animated zoomIn"
                data-id="d53beb9"
                data-element_type="widget"
                data-settings='{"_animation":"zoomIn","_animation_delay":1650}'
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{namaTamu}}</h2>
                </div>
              </div>
              <div
                data-dce-background-color="#C28846"
                class="elementor-element elementor-element-8975bc1 elementor-align-center animated-slow tombol-buka elementor-widget elementor-widget-button btnVisibleAfterLoad animated zoomIn"
                data-id="8975bc1"
                data-element_type="widget"
                data-settings='{"_animation":"zoomIn","_animation_delay":1700}'
                data-widget_type="button.default"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a class="elementor-button elementor-size-sm" role="button" id="btnOpen">
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">{{ config.language === 1 ? 'Open Invitation' : 'Buka Undangan' }}</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="elementor-element elementor-element-0b438e7 elementor-widget elementor-widget-html" data-id="0b438e7" data-element_type="widget" data-widget_type="html.default">
                <div class="elementor-widget-container"></div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="has_eae_slider elementor-element elementor-element-47822af e-con-full motionSection e-flex e-con e-child"
          data-id="47822af"
          data-element_type="container"
          id="home"
          data-settings='{"background_background":"video","jet_parallax_layout_list":[],"background_video_link":"assets\/wp-content\/uploads\/2025\/04\/MINANG-1_2.mp4","background_play_once":"yes","background_play_on_mobile":"yes","background_privacy_mode":"yes","background_video_start":0.001}'
        >
          <div class="elementor-background-video-container">
            <video class="elementor-background-video-hosted" muted="" playsinline="" src="assets/wp-content/uploads/2025/04/MINANG-1_2.mp4#t=0.001" style="width: 924.444px; height: 520px;"></video>
          </div>
          <div
            class="has_eae_slider elementor-element elementor-element-8e65024 e-con-full animated-slow e-flex elementor-invisible e-con e-child"
            data-id="8e65024"
            data-element_type="container"
            data-settings='{"jet_parallax_layout_list":[],"animation":"fadeIn","animation_delay":8000}'
          >
            <div
              class="elementor-element elementor-element-da4dfd5 animated-slow elementor-invisible elementor-widget elementor-widget-heading"
              data-id="da4dfd5"
              data-element_type="widget"
              data-settings='{"_animation":"zoomIn","_animation_delay":1100}'
              data-widget_type="heading.default"
            >
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">
                  {{ client.hajat === 'wanita' ? client.nama_wanita : client.nama_pria }}
                </h2>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-c6752fb animated-slow elementor-invisible elementor-widget elementor-widget-heading"
              data-id="c6752fb"
              data-element_type="widget"
              data-settings='{"_animation":"zoomIn","_animation_delay":1100}'
              data-widget_type="heading.default"
            >
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">&amp;</h2>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-176f7cc animated-slow elementor-invisible elementor-widget elementor-widget-heading"
              data-id="176f7cc"
              data-element_type="widget"
              data-settings='{"_animation":"zoomIn","_animation_delay":1100}'
              data-widget_type="heading.default"
            >
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">{{ client.hajat === 'wanita' ? client.nama_pria : client.nama_wanita }}</h2>
              </div>
            </div>

            <div class="elementor-element elementor-element-4a4069a elementor-widget elementor-widget-heading" data-id="4a4069a" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">{{ moment (client.tgl_resepsi).locale(config.language === 1 ? 'en' : 'id').format('dddd, DD MMMM YYYY') }}</h2>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-640d548 animated-slow elementor-align-center elementor-invisible elementor-widget elementor-widget-lottie"
              data-id="640d548"
              data-element_type="widget"
              data-settings='{"source_external_url":{"url":"assets\/wp-content\/uploads\/2024\/10\/swipe-up-2.json","is_external":"","nofollow":"","custom_attributes":""},"loop":"yes","play_speed":{"unit":"px","size":0.8,"sizes":[]},"_animation":"fadeIn","_animation_delay":9000,"source":"external_url","link_to":"none","trigger":"arriving_to_viewport","viewport":{"unit":"%","size":"","sizes":{"start":0,"end":100}},"start_point":{"unit":"%","size":0,"sizes":[]},"end_point":{"unit":"%","size":100,"sizes":[]},"renderer":"svg"}'
              data-widget_type="lottie.default"
            >
              <div class="elementor-widget-container" style="display: flex; justify-content: center; align-items: center;">
                <dotlottie-wc src="https://lottie.host/9afc2023-1316-4ae8-9ab2-f315c4b7c8a0/22hAk8KcTg.lottie" style="width: 53px; height: 53px;" speed="1" autoplay loop> </dotlottie-wc>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-04cd8af e-con-full e-flex e-con e-child"
          data-dce-background-color="#F0EAE8"
          data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/Minang-1-Asset-1.jpg"
          data-id="04cd8af"
          data-element_type="container"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-453a53b e-con-full e-flex e-con e-child"
            data-dce-background-color="#E2D9D2"
            data-id="453a53b"
            data-element_type="container"
            data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
          >
            <div class="elementor-element elementor-element-23463e1 elementor-widget elementor-widget-image" data-id="23463e1" data-element_type="widget" data-widget_type="image.default">
              <div class="elementor-widget-container">
                <img
                  fetchpriority="high"
                  decoding="async"
                  width="725"
                  height="1024"
                  :src="'https://admin.itsyourdayofficial.com/foto_cover/' + client.foto_cover"
                  class="attachment-large size-large wp-image-2097"
                  alt=""
                  sizes="(max-width: 725px) 100vw, 725px"
                />
              </div>
            </div>
            <div
              class="has_eae_slider elementor-element elementor-element-a5598ed e-con-full e-flex e-con e-child"
              data-id="a5598ed"
              data-element_type="container"
              data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
            >
              <div class="elementor-element elementor-element-880239f fade elementor-widget elementor-widget-heading" data-id="880239f" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ config.language === 1 ? 'With Love' : 'Kutipan Do`a' }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-27d9283 zoom elementor-widget elementor-widget-heading" data-id="27d9283" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" v-html="client.quote"></h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-c2b870e zoom elementor-widget elementor-widget-heading" data-id="c2b870e" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ client.title_quote }}</h2>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-e02c77a elementor-widget elementor-widget-image" data-id="e02c77a" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img
                decoding="async"
                width="810"
                height="810"
                src="assets/wp-content/uploads/2024/10/AYAT-Minang-1-2.png"
                class="attachment-large size-large wp-image-1695"
                alt=""
                srcset="
                  assets/wp-content/uploads/2024/10/AYAT-Minang-1-2.png 810w,
                  assets/wp-content/uploads/2024/10/AYAT-Minang-1-2.png 300w,
                  assets/wp-content/uploads/2024/10/AYAT-Minang-1-2.png 150w,
                  assets/wp-content/uploads/2024/10/AYAT-Minang-1-2.png 768w
                "
                sizes="(max-width: 810px) 100vw, 810px"
              />
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-37439eb e-con-full e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-dce-background-image-url="assets/wp-content/uploads/2024/10/MEMPELAI-MIDDLE-Minang-1-3.png"
          data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/MEMPELAI-TOP-X-Minang-1-2.png"
          data-id="37439eb"
          data-element_type="container"
          id="couple"
          data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-586644b e-con-full e-flex e-con e-child"
            data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/MEMPELAI-BOTTOM-Minang-1-1.png"
            data-id="586644b"
            data-element_type="container"
            data-settings='{"jet_parallax_layout_list":[]}'
          >
            <div class="has_eae_slider elementor-element elementor-element-7f5eac2 e-con-full e-flex e-con e-child" data-id="7f5eac2" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div class="elementor-element elementor-element-9dafbcb fade elementor-widget elementor-widget-heading" data-id="9dafbcb" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ config.language === 1 ? 'Bride & Groom' : 'Mempelai' }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-25b95b2 zoom elementor-widget elementor-widget-heading" data-id="25b95b2" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">
                    {{ config.language === 1 ? 'By the grace and blessing of Allah SWT, we intend to invite you to attend our wedding:' : 'Dengan memohon rahmat dan ridho Allah SWT kami bermaksud untuk mengundang Bapak/Ibu/Saudara/i untuk menghadiri acara pernikahan kami:' }}
                  </h2>
                </div>
              </div>
            </div>
            <div class="has_eae_slider elementor-element elementor-element-f8ca2c9 e-con-full e-flex e-con e-child" data-id="f8ca2c9" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div class="elementor-element elementor-element-63a80b9 elementor-widget elementor-widget-image" data-id="63a80b9" data-element_type="widget" data-widget_type="image.default">
                <div class="elementor-widget-container">
                  <img
                    decoding="async"
                    width="705"
                    height="1024"
                    :src="client.hajat === 'wanita' ? 'https://admin.itsyourdayofficial.com/foto_calon/' + client.foto_wanita : 'https://admin.itsyourdayofficial.com/foto_calon/' + client.foto_pria"
                    class="attachment-large size-large wp-image-2108"
                    alt=""
                    sizes="(max-width: 705px) 100vw, 705px"
                  />
                </div>
              </div>
              <div class="elementor-element elementor-element-eb65839 fade elementor-widget elementor-widget-heading" data-id="eb65839" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ client.hajat === 'wanita' ? client.nama_wanita : client.nama_pria }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-56d6aa5 zoom elementor-widget elementor-widget-heading" data-id="56d6aa5" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ client.hajat === 'wanita' ? client.gelar_wanita : client.gelar_pria }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-2e1d508 zoom elementor-widget elementor-widget-heading" data-id="2e1d508" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">
                    {{ config.language === 1 ? (client.hajat === 'wanita' ? 'Daughter of' : 'Son of') : (client.hajat === 'wanita' ? 'Putri dari' : 'Putra dari') }}<br />
                    {{ client.hajat === 'wanita' ? client.nama_ayah_wanita : client.nama_ayah_pria }}<br />
                    &amp;<br />
                    {{ client.hajat === 'wanita' ? client.nama_ibu_wanita : client.nama_ibu_pria }}
                  </h2>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-3e7e23e zoom elementor-widget elementor-widget-heading" data-id="3e7e23e" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">&amp;</h2>
              </div>
            </div>
            <div class="has_eae_slider elementor-element elementor-element-cf83ca5 e-con-full e-flex e-con e-child" data-id="cf83ca5" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div class="elementor-element elementor-element-2d3dca2 elementor-widget elementor-widget-image" data-id="2d3dca2" data-element_type="widget" data-widget_type="image.default">
                <div class="elementor-widget-container">
                  <img
                    loading="lazy"
                    decoding="async"
                    width="683"
                    height="1024"
                    :src="client.hajat === 'wanita' ? 'https://admin.itsyourdayofficial.com/foto_calon/' + client.foto_pria : 'https://admin.itsyourdayofficial.com/foto_calon/' + client.foto_wanita"
                    class="attachment-large size-large wp-image-2099"
                    alt=""
                    sizes="(max-width: 683px) 100vw, 683px"
                  />
                </div>
              </div>
              <div class="elementor-element elementor-element-298bff9 fade elementor-widget elementor-widget-heading" data-id="298bff9" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ client.hajat === 'wanita' ? client.nama_pria : client.nama_wanita }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-4d34fc9 zoom elementor-widget elementor-widget-heading" data-id="4d34fc9" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ client.hajat === 'wanita' ? client.gelar_pria : client.gelar_wanita }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-dcdbf97 zoom elementor-widget elementor-widget-heading" data-id="dcdbf97" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">
                    {{ config.language === 1 ? (client.hajat === 'wanita' ? 'Son of' : 'Daughter of') : (client.hajat === 'wanita' ? 'Putra dari' : 'Putri dari') }}<br />
                    {{ client.hajat === 'wanita' ? client.nama_ayah_pria : client.nama_ayah_wanita }}<br />
                    &amp;<br />
                    {{ client.hajat === 'wanita' ? client.nama_ibu_pria : client.nama_ibu_wanita }}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-b61dc09 elementor-absolute elementor-align-center elementor-widget elementor-widget-lottie"
            data-id="b61dc09"
            data-element_type="widget"
            data-settings='{"loop":"yes","_position":"absolute","source":"external_url","source_external_url":{"url":"assets\/wp-content\/uploads\/2024\/09\/bird.json","is_external":"","nofollow":"","custom_attributes":""},"link_to":"none","trigger":"arriving_to_viewport","viewport":{"unit":"%","size":"","sizes":{"start":0,"end":100}},"play_speed":{"unit":"px","size":1,"sizes":[]},"start_point":{"unit":"%","size":0,"sizes":[]},"end_point":{"unit":"%","size":100,"sizes":[]},"renderer":"svg"}'
            data-widget_type="lottie.default"
          >
            <div class="elementor-widget-container" style="display: flex; justify-content: center; align-items: center;">
              <dotlottie-wc src="https://lottie.host/2b1a10a5-0e4f-4e5e-b0be-4b2a324c7691/dgN8w6ckZW.lottie" style="width: 600px; height: 300px;" speed="1" autoplay loop></dotlottie-wc>
            </div>
          </div>
        </div>
        <div
          class="custom-slideshow-container has_eae_slider elementor-element elementor-element-593f3af e-con-full e-flex e-con e-child"
          data-dce-background-overlay-color="#000000"
          data-id="593f3af"
          data-element_type="container"
          :style="currentBackgroundStyle"
        >
          <div class="has_eae_slider elementor-element elementor-element-98efbd7 e-con-full e-flex e-con e-child" data-id="98efbd7" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div class="elementor-element elementor-element-b447ad1 elementor-countdown--label-block elementor-widget elementor-widget-countdown" data-id="b447ad1" data-element_type="widget" data-widget_type="countdown.default">
              <div class="elementor-widget-container">
                <div class="elementor-countdown-wrapper" data-date="1731769860">
                  <div class="elementor-countdown-item"><span class="elementor-countdown-digits">{{days}}</span> <span class="elementor-countdown-label">{{ config.language === 1 ? 'Days' : 'Hari' }}</span></div>
                  <div class="elementor-countdown-item"><span class="elementor-countdown-digits">{{hours}}</span> <span class="elementor-countdown-label">{{ config.language === 1 ? 'Hours' : 'Jam' }}</span></div>
                  <div class="elementor-countdown-item"><span class="elementor-countdown-digits">{{minutes}}</span> <span class="elementor-countdown-label">{{ config.language === 1 ? 'Minutes' : 'Menit' }}</span></div>
                  <div class="elementor-countdown-item"><span class="elementor-countdown-digits">{{seconds}}</span> <span class="elementor-countdown-label">{{ config.language === 1 ? 'Seconds' : 'Detik' }}</span></div>
                </div>
              </div>
            </div>
            <div
              data-dce-background-color="#FFFFFF00"
              class="elementor-element elementor-element-22b7202 elementor-align-center fade elementor-widget elementor-widget-dce_add_to_calendar active"
              data-id="22b7202"
              data-element_type="widget"
              data-widget_type="dce_add_to_calendar.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a :href="generateCalendarLink()" class="elementor-button-link elementor-button elementor-size-sm" target="_blank" rel="nofollow" role="button">
                    <span class="elementor-button-content-wrapper dce-flexbox">
                      <span class="elementor-button-text">{{ config.language === 1 ? 'Add to Google Calendar' : 'Tambah Google Calendar' }}</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="has_eae_slider elementor-element elementor-element-a032796 e-con-full e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-dce-background-image-url="assets/wp-content/uploads/2024/10/PENUTUP-Minang-1-2.png"
          data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/MEMPELAI-TOP-X-Minang-1-2.png"
          data-id="a032796"
          data-element_type="container"
          id="event"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-e190760 e-con-full e-flex e-con e-child"
            data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/MEMPELAI-BOTTOM-Minang-1-1.png"
            data-id="e190760"
            data-element_type="container"
            data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
          >
            <div class="has_eae_slider elementor-element elementor-element-62a9bb7 e-con-full e-flex e-con e-child" data-id="62a9bb7" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div class="elementor-element elementor-element-b626934 elementor-widget elementor-widget-image" data-id="b626934" data-element_type="widget" data-widget_type="image.default">
                <div class="elementor-widget-container">
                  <img
                    loading="lazy"
                    decoding="async"
                    width="464"
                    height="150"
                    src="assets/wp-content/uploads/2024/10/Minang-1-ATAS.png"
                    class="attachment-large size-large wp-image-1906"
                    alt=""
                    srcset="assets/wp-content/uploads/2024/10/Minang-1-ATAS.png 464w, assets/wp-content/uploads/2024/10/Minang-1-ATAS-300x97.png 300w"
                    sizes="(max-width: 464px) 100vw, 464px"
                  />
                </div>
              </div>
            </div>
            <div
              class="has_eae_slider elementor-element elementor-element-8894f2a e-con-full e-flex e-con e-child"
              data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/Minang-1-TENGAH_1.png"
              data-id="8894f2a"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <div class="has_eae_slider elementor-element elementor-element-e57b756 e-con-full e-flex e-con e-child" data-id="e57b756" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
                <div class="elementor-element elementor-element-8f5e9a2 fade elementor-widget elementor-widget-heading" data-id="8f5e9a2" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">AKAD NIKAH</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-b7decfb zoom elementor-widget elementor-widget-heading" data-id="b7decfb" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{ moment(client.tgl_akad).locale(config.language === 1 ? 'en' : 'id').format('dddd, DD MMMM YYYY') }}</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-99c93d4 zoom elementor-widget elementor-widget-heading" data-id="99c93d4" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">
                      <template v-if="client.tgl_akad_selesai == null">
                        {{ moment(client.tgl_akad).format("HH:mm") }} - Selesai
                      </template>
                      <template v-else>
                        {{ moment(client.tgl_akad).format("HH:mm") }} - {{ moment(client.tgl_akad_selesai).format("HH:mm") }}
                      </template>
                    </h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-3314d63 elementor-widget elementor-widget-spacer" data-id="3314d63" data-element_type="widget" data-widget_type="spacer.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-spacer">
                      <div class="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-3981e52 zoom elementor-widget elementor-widget-heading" data-id="3981e52" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{ client.nama_venue }}</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-1506f43 zoom elementor-widget elementor-widget-heading" data-id="1506f43" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default" v-html="client.alamat_venue"></h2>
                  </div>
                </div>
                <div
                  data-dce-background-color="#C28846"
                  class="elementor-element elementor-element-86d5d75 elementor-align-center zoom elementor-widget elementor-widget-button"
                  data-id="86d5d75"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div class="elementor-widget-container">
                    <!-- Tombol Google Maps -->
                    <div class="elementor-button-wrapper" v-if="client.url_maps_resepsi">
                      <a :href="client.url_maps_resepsi" target="_blank" class="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-text">
                            {{ config.language === 1 ? 'Google Maps →' : 'Lihat Lokasi' }}
                          </span>
                        </span>
                      </a>
                    </div>

                    <!-- Alternatif jika maps_section tidak aktif -->
                    <div class="elementor-button-wrapper" v-else-if="config.maps_section !== 1">
                      <a :href="client.url_maps" target="_blank" class="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-text">
                            {{ config.language === 1 ? 'Google Maps →' : 'Lihat Lokasi' }}
                          </span>
                        </span>
                      </a>
                    </div>

                    <!-- Kosong jika maps_section aktif tapi data resepsi tidak tersedia -->
                    <div class="elementor-button-wrapper" v-else>
                      <!-- Tidak ditampilkan -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="has_eae_slider elementor-element elementor-element-b2709db e-con-full e-flex e-con e-child" data-id="b2709db" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
                <div class="elementor-element elementor-element-af39d59 fade elementor-widget elementor-widget-heading" data-id="af39d59" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">
                      <template v-if="config.language === 1">
                        RECEPTION
                      </template>
                      <template v-else>
                        RESEPSI<br />
                        PERNIKAHAN
                      </template>
                    </h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-3f9ff04 zoom elementor-widget elementor-widget-heading" data-id="3f9ff04" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{moment (client.tgl_resepsi).locale(config.language === 1 ? 'en' : 'id').format('dddd, DD MMMM YYYY')}}</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-2d27777 zoom elementor-widget elementor-widget-heading" data-id="2d27777" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">
                      <template v-if="client.tgl_resepsi_selesai == null">
                        {{ moment(client.tgl_resepsi).format("HH:mm") }} - Selesai
                      </template>
                      <template v-else>
                        {{ moment(client.tgl_resepsi).format("HH:mm") }} - {{ moment(client.tgl_resepsi_selesai).format("HH:mm") }}
                      </template>
                    </h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-6a8d16f elementor-widget elementor-widget-spacer" data-id="6a8d16f" data-element_type="widget" data-widget_type="spacer.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-spacer">
                      <div class="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-a74c73c zoom elementor-widget elementor-widget-heading" data-id="a74c73c" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{ client.nama_venue_resepsi }}</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-9d679aa zoom elementor-widget elementor-widget-heading" data-id="9d679aa" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default" v-html="client.alamat_venue_resepsi"></h2>
                  </div>
                </div>
                <div
                  data-dce-background-color="#C28846"
                  class="elementor-element elementor-element-93327b5 elementor-align-center zoom elementor-widget elementor-widget-button"
                  data-id="93327b5"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div class="elementor-widget-container">
                    <!-- Jika URL Maps resepsi tersedia -->
                    <div class="elementor-button-wrapper" v-if="client.url_maps_resepsi !== null">
                      <a :href="client.url_maps_resepsi" target="_blank" class="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-text">
                            {{ config.language === 1 ? 'Google Maps →' : 'Lihat Lokasi' }}
                          </span>
                        </span>
                      </a>
                    </div>

                    <!-- Jika URL Maps resepsi tidak tersedia, tapi maps_section tidak aktif -->
                    <div class="elementor-button-wrapper" v-else-if="config.maps_section !== 1">
                      <a :href="client.url_maps" target="_blank" class="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-text">
                            {{ config.language === 1 ? 'Google Maps →' : 'Lihat Lokasi' }}
                          </span>
                        </span>
                      </a>
                    </div>

                    <!-- Jika URL Maps resepsi kosong dan maps_section aktif -->
                    <div class="elementor-button-wrapper" v-else-if="client.url_maps_resepsi == null && config.maps_section === 1">
                      <!-- Tidak ditampilkan -->
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="config.maps_section !== 0"
                class="has_eae_slider elementor-element elementor-element-c5b22f8 e-con-full e-flex e-con e-child"
                data-id="c5b22f8"
                data-element_type="container"
                data-settings='{"jet_parallax_layout_list":[]}'
              >
                <div class="elementor-element elementor-element-e6b08f8 fade elementor-widget elementor-widget-heading" data-id="e6b08f8" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{ config.language === 1 ? 'MAPS LOCATION' : 'LOKASI ACARA' }}</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-6991c1a zoom elementor-widget elementor-widget-heading" data-id="6991c1a" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <iframe
                      class="ftco-animate"
                      :src="client.embed"
                      width="95%"
                      height="450"
                      style="border: 0; border-radius: 20px !important; margin: auto; padding-top: 30px; z-index: 9999; position: relative;"
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    >
                    </iframe>
                  </div>
                </div>
                <div
                  data-dce-background-color="#C28846"
                  class="elementor-element elementor-element-b46a54e elementor-align-center zoom elementor-widget elementor-widget-button"
                  data-id="b46a54e"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper">
                      <a class="elementor-button elementor-size-sm" role="button" :href="client.url_maps" target="_blank">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-text">{{ config.language === 1 ? 'OPEN MAPS' : 'BUKA MAPS' }}</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="has_eae_slider elementor-element elementor-element-1d5e05f e-con-full e-flex e-con e-child" data-id="1d5e05f" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
              <div class="elementor-element elementor-element-0dd7363 elementor-widget elementor-widget-image" data-id="0dd7363" data-element_type="widget" data-widget_type="image.default">
                <div class="elementor-widget-container">
                  <img
                    loading="lazy"
                    decoding="async"
                    width="464"
                    height="150"
                    src="assets/wp-content/uploads/2024/10/Minang-1-BAWAH.png"
                    class="attachment-large size-large wp-image-1909"
                    alt=""
                    srcset="assets/wp-content/uploads/2024/10/Minang-1-BAWAH.png 464w, assets/wp-content/uploads/2024/10/Minang-1-BAWAH-300x97.png 300w"
                    sizes="(max-width: 464px) 100vw, 464px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-a4add81 elementor-absolute elementor-widget elementor-widget-image"
            data-id="a4add81"
            data-element_type="widget"
            data-settings='{"_position":"absolute"}'
            data-widget_type="image.default"
          >
            <div class="elementor-widget-container">
              <img
                loading="lazy"
                decoding="async"
                width="208"
                height="500"
                src="assets/wp-content/uploads/2024/10/FLOATING-LEFT-Minang-1.png"
                class="attachment-large size-large wp-image-1916"
                alt=""
                srcset="assets/wp-content/uploads/2024/10/FLOATING-LEFT-Minang-1.png 208w, assets/wp-content/uploads/2024/10/FLOATING-LEFT-Minang-1-125x300.png 125w"
                sizes="(max-width: 208px) 100vw, 208px"
              />
            </div>
          </div>
          <div class="elementor-element elementor-element-2cb6869 elementor-widget elementor-widget-image" data-id="2cb6869" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img
                loading="lazy"
                decoding="async"
                width="257"
                height="500"
                src="assets/wp-content/uploads/2024/10/FLOATING-RIGHT-Minang-1-2.png"
                class="attachment-large size-large wp-image-1930"
                alt=""
                srcset="assets/wp-content/uploads/2024/10/FLOATING-RIGHT-Minang-1-2.png 257w, assets/wp-content/uploads/2024/10/FLOATING-RIGHT-Minang-1-2-154x300.png 154w"
                sizes="(max-width: 257px) 100vw, 257px"
              />
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-2657a0c e-con-full e-flex e-con e-child"
          data-dce-background-color="#C28846"
          data-id="2657a0c"
          data-element_type="container"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div class="has_eae_slider elementor-element elementor-element-e311d0a e-con-full e-flex e-con e-child" data-id="e311d0a" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div class="elementor-element elementor-element-97b2830 fade elementor-widget elementor-widget-heading" data-id="97b2830" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">
                  CAPTURED<br />
                  MOMENT
                </h2>
              </div>
            </div>
            <div class="elementor-element elementor-element- fade pp-ins-normal elementor-widget elementor-widget-pp-image-gallery show-gallery" data-id="" data-element_type="widget" data-widget_type="pp-image-gallery.default">
              <div class="elementor-widget-container justify-content-center">
                <div class="pp-image-gallery-container" data-settings='{"tilt_enable":"no","layout":"justified","image_spacing":10,"row_height":170,"last_row":"justify","post_id":1536,"template_id":1534,"widget_id":""}'>
                  <div class="pp-image-gallery-wrapper">
                    <vue-horizontal :button="false" ref="horizontal" @scroll-debounce="onScroll">
                      <div class="pp-image-gallery gallery-item swiper-slide" v-for="(item, index) in gallery" :key="index">
                        <a data-elementor-open-lightbox="default" data-elementor-lightbox-slideshow="" class="elementor-clickable pp-image-gallery-item-link" :href="'https://admin.itsyourdayofficial.com/gallery/' + item.file"></a>
                        <img decoding="async" class="gallery-image" :src="'https://admin.itsyourdayofficial.com/gallery/' + item.file" alt="" data-no-lazy="1" style="cursor: pointer;" />
                        <div class="magnifier-icon">
                          <i class="fas fa-search-plus"></i>
                        </div>
                      </div>
                    </vue-horizontal>
                    <div class="elementor-widget-container">
                      <div class="elementor-button-wrapper">
                        <nav style="text-align: center;">
                          <button @click="prev($event)" :class="{ 'active': hasPrev, 'inactive': !hasPrev }">
                            <i class="lni lni-chevron-left"></i>
                          </button>
                          <button @click="next($event)" :class="{ 'active': hasNext, 'inactive': !hasNext }">
                            <i class="lni lni-chevron-right"></i>
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-a6433b0 zoom elementor-widget elementor-widget-heading" data-id="a6433b0" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">{{ formattedHashtag }}</h2>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-443e8af e-con-full frost e-flex e-con e-child"
          data-dce-background-color="#F0EAE8"
          data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/MEMPELAI-TOP-X-Minang-1-2.png"
          data-id="443e8af"
          data-element_type="container"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-1d53e37 e-con-full e-flex e-con e-child"
            data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/AYAT-Minang-1-2.png"
            data-id="1d53e37"
            data-element_type="container"
            data-settings='{"jet_parallax_layout_list":[]}'
          >
            <div
              class="has_eae_slider elementor-element elementor-element-8aab44a e-con-full e-flex e-con e-child"
              data-dce-background-color="#FFFFFFE6"
              data-id="8aab44a"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <div class="elementor-element elementor-element-38997a3 fade elementor-widget elementor-widget-heading" data-id="38997a3" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ config.language === 1 ? 'RSVP by Whatsapp' : 'RSVP via Whatsapp' }}</h2>
                </div>
              </div>
              <div class="elementor-element elementor-element-9196ec4 zoom elementor-widget elementor-widget-heading" data-id="9196ec4" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" v-html="confirmationText"></h2>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-9ff08e6 elementor-button-align-stretch elementor-widget elementor-widget-form dce-form-has-conditions"
                data-id="9ff08e6"
                data-element_type="widget"
                data-settings='{"step_next_label":"Next","step_previous_label":"Previous","button_width":"100","step_type":"number_text","step_icon_shape":"circle"}'
                data-widget_type="form.default"
              >
                <div class="elementor-widget-container">
                  <form class="elementor-form" name="MINANG #1" @submit.prevent="handleSubmit">
                    <div class="elementor-form-fields-wrapper elementor-labels-above">
                      <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-nama elementor-col-100 elementor-field-required">
                        <label for="form-field-nama" class="elementor-field-label"> {{ config.language === 1 ? 'Name: ' : 'Nama: ' }} </label>
                        <input size="1" type="text" class="elementor-field elementor-size-sm elementor-field-textual" placeholder="Nama" required="required" v-model="name" autocomplete="false" />
                      </div>
                      <div class="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-konfirmasi elementor-col-100 elementor-field-required">
                        <label for="form-field-konfirmasi" class="elementor-field-label"> Konfirmasi Kehadiran: </label>
                        <div class="elementor-field elementor-select-wrapper remove-before">
                          <div class="select-caret-down-wrapper">
                            <svg aria-hidden="true" class="e-font-icon-svg e-eicon-caret-down" viewBox="0 0 571.4 571.4" xmlns="http://www.w3.org/2000/svg">
                              <path d="M571 393Q571 407 561 418L311 668Q300 679 286 679T261 668L11 418Q0 407 0 393T11 368 36 357H536Q550 357 561 368T571 393Z"></path>
                            </svg>
                          </div>
                          <select v-model="picked" class="elementor-field-textual elementor-size-sm" required="required">
                            <option :value="config.language === 1 ? 'Yes, I would love to attend' : 'Iya, Saya akan Hadir'">{{ config.language === 1 ? 'Yes, I will attend' : 'Iya, Saya akan Hadir' }}</option>
                            <option :value="config.language === 1 ? 'Sorry, I cant attend' : 'Maaf, Saya Tidak Bisa Hadir'">{{ config.language === 1 ? 'Sorry, I cant attend' : 'Maaf, Saya Tidak Bisa Hadir' }}</option>
                          </select>
                        </div>
                      </div>
                      <div
                        class="elementor-field-type-radio elementor-field-group elementor-column elementor-field-group-jumlah elementor-col-100 elementor-field-required"
                        v-if="picked === 'Iya, Saya akan Hadir' || picked === 'Yes, I would love to attend'"
                      >
                        <label for="form-field-jumlah" class="elementor-field-label">{{ config.language === 1 ? 'Number of Attendees (Including you):' : 'Jumlah Hadir (Termasuk kamu):' }}</label>
                        <div class="elementor-field-subgroup">
                          <span class="elementor-field-option">
                            <input type="radio" value="1 Orang" id="form-field-jumlah-0" name="form_fields[jumlah]" required="required" v-model="jumlah" />
                            <label for="form-field-jumlah-0">{{ config.language === 1 ? '1 People' : '1 Orang' }}</label>
                          </span>
                          <span class="elementor-field-option">
                            <input type="radio" value="2 Orang" id="form-field-jumlah-1" name="form_fields[jumlah]" required="required" v-model="jumlah" />
                            <label for="form-field-jumlah-1">{{ config.language === 1 ? '2 People' : '2 Orang' }}</label>
                          </span>
                        </div>
                      </div>

                      <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100">
                        <button class="elementor-button elementor-size-sm" type="submit">
                          <span class="elementor-button-content-wrapper">
                            <span class="elementor-button-text">SUBMIT</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-b8050fe e-con-full e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-id="b8050fe"
          data-element_type="container"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div class="has_eae_slider elementor-element elementor-element-e78e785 e-con-full e-flex e-con e-child" data-id="e78e785" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div class="elementor-element elementor-element-1f75948 fade elementor-widget elementor-widget-heading" data-id="1f75948" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">{{ config.language === 1 ? 'Our Story' : 'Kisah Kami' }}</h2>
              </div>
            </div>

            <div
              class="elementor-element elementor-element-ed399e1 elementor-widget elementor-widget-image-carousel e-widget-swiper"
              data-id="ed399e1"
              data-element_type="widget"
              data-settings='{"slides_to_show":"3","slides_to_show_tablet":"3","slides_to_show_mobile":"3","slides_to_scroll":"1","navigation":"none","autoplay_speed":0,"speed":4000,"image_spacing_custom":{"unit":"px","size":7,"sizes":[]},"autoplay":"yes","infinite":"yes","image_spacing_custom_tablet":{"unit":"px","size":"","sizes":[]},"image_spacing_custom_mobile":{"unit":"px","size":"","sizes":[]}}'
              data-widget_type="image-carousel.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-image-carousel-wrapper swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden" role="region" aria-roledescription="carousel" aria-label="Image Carousel" dir="ltr">
                  <div ref="carouselWrapper" class="elementor-image-carousel swiper-wrapper" aria-live="off" style="transform: translate3d(0px, 0px, 0px); transition-duration: 4000ms;" id="swiper-wrapper-235f75e23df77a3e">
                    <div class="pp-image-gallery gallery-item-story swiper-slide" v-for="(item, index) in gallery.concat(gallery)" :key="index">
                      <img decoding="async" class="gallery-image-story" :src="'https://admin.itsyourdayofficial.com/gallery/' + item.file" alt="" data-no-lazy="1" />
                    </div>
                  </div>

                  <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                </div>
              </div>
            </div>

            <div
              v-if="story.type1 !== undefined"
              class="has_eae_slider elementor-element elementor-element-eb934e0 e-con-full fade e-flex e-con e-child"
              data-dce-background-color="#FFFFFF75"
              data-id="eb934e0"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <!-- Media (Image or Video) -->
              <div class="elementor-element elementor-element-media" style="width: 100%; text-align: center;">
                <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media1.media" class="responsive-media" alt="" loading="lazy" />
                <video
                  v-if="story.type1.type == 'video'"
                  :src="'https://admin.itsyourdayofficial.com/story/' + story.media1.media + '#t=0.001'"
                  type="video/mp4"
                  controls
                  preload="metadata"
                  style="width: 100%; max-height: 480px; object-fit: cover;"
                ></video>
              </div>

              <!-- Range Time -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" style="font-size: 16px; font-weight: normal; font-family: auto;">{{ story.rangeTime1.rangeTime }}</h2>
                </div>
              </div>

              <!-- Title -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ story.title1.title }}</h2>
                </div>
              </div>

              <!-- Description -->
              <div class="elementor-element elementor-element-7ff0c00 zoom elementor-widget elementor-widget-heading" data-id="7ff0c00" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 v-html="story.description1.description" class="elementor-heading-title elementor-size-default"></h2>
                </div>
              </div>
            </div>

            <div
              v-if="story.type2 !== undefined"
              class="has_eae_slider elementor-element elementor-element-eb934e0 e-con-full fade e-flex e-con e-child"
              data-dce-background-color="#FFFFFF75"
              data-id="eb934e0"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <!-- Media (Image or Video) -->
              <div class="elementor-element elementor-element-media" style="width: 100%; text-align: center;">
                <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media2.media" class="responsive-media" alt="" loading="lazy" />
                <video
                  v-if="story.type1.type == 'video'"
                  :src="'https://admin.itsyourdayofficial.com/story/' + story.media2.media + '#t=0.001'"
                  type="video/mp4"
                  controls
                  preload="metadata"
                  style="width: 100%; max-height: 480px; object-fit: cover;"
                ></video>
              </div>

              <!-- Range Time -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" style="font-size: 16px; font-weight: normal; font-family: auto;">{{ story.rangeTime2.rangeTime }}</h2>
                </div>
              </div>

              <!-- Title -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ story.title2.title }}</h2>
                </div>
              </div>

              <!-- Description -->
              <div class="elementor-element elementor-element-7ff0c00 zoom elementor-widget elementor-widget-heading" data-id="7ff0c00" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 v-html="story.description2.description" class="elementor-heading-title elementor-size-default"></h2>
                </div>
              </div>
            </div>

            <div
              v-if="story.type3 !== undefined"
              class="has_eae_slider elementor-element elementor-element-eb934e0 e-con-full fade e-flex e-con e-child"
              data-dce-background-color="#FFFFFF75"
              data-id="eb934e0"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <!-- Media (Image or Video) -->
              <div class="elementor-element elementor-element-media" style="width: 100%; text-align: center;">
                <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media3.media" class="responsive-media" alt="" loading="lazy" />
                <video
                  v-if="story.type1.type == 'video'"
                  :src="'https://admin.itsyourdayofficial.com/story/' + story.media3.media + '#t=0.001'"
                  type="video/mp4"
                  controls
                  preload="metadata"
                  style="width: 100%; max-height: 480px; object-fit: cover;"
                ></video>
              </div>

              <!-- Range Time -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" style="font-size: 16px; font-weight: normal; font-family: auto;">{{ story.rangeTime3.rangeTime }}</h2>
                </div>
              </div>

              <!-- Title -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ story.title3.title }}</h2>
                </div>
              </div>

              <!-- Description -->
              <div class="elementor-element elementor-element-7ff0c00 zoom elementor-widget elementor-widget-heading" data-id="7ff0c00" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 v-html="story.description3.description" class="elementor-heading-title elementor-size-default"></h2>
                </div>
              </div>
            </div>

            <div
              v-if="story.type4 !== undefined"
              class="has_eae_slider elementor-element elementor-element-eb934e0 e-con-full fade e-flex e-con e-child"
              data-dce-background-color="#FFFFFF75"
              data-id="eb934e0"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <!-- Media (Image or Video) -->
              <div class="elementor-element elementor-element-media" style="width: 100%; text-align: center;">
                <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media4.media" class="responsive-media" alt="" loading="lazy" />
                <video
                  v-if="story.type1.type == 'video'"
                  :src="'https://admin.itsyourdayofficial.com/story/' + story.media4.media + '#t=0.001'"
                  type="video/mp4"
                  controls
                  preload="metadata"
                  style="width: 100%; max-height: 480px; object-fit: cover;"
                ></video>
              </div>

              <!-- Range Time -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" style="font-size: 16px; font-weight: normal; font-family: auto;">{{ story.rangeTime4.rangeTime }}</h2>
                </div>
              </div>

              <!-- Title -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ story.title4.title }}</h2>
                </div>
              </div>

              <!-- Description -->
              <div class="elementor-element elementor-element-7ff0c00 zoom elementor-widget elementor-widget-heading" data-id="7ff0c00" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 v-html="story.description4.description" class="elementor-heading-title elementor-size-default"></h2>
                </div>
              </div>
            </div>

            <div
              v-if="story.type5 !== undefined"
              class="has_eae_slider elementor-element elementor-element-eb934e0 e-con-full fade e-flex e-con e-child"
              data-dce-background-color="#FFFFFF75"
              data-id="eb934e0"
              data-element_type="container"
              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
            >
              <!-- Media (Image or Video) -->
              <div class="elementor-element elementor-element-media" style="width: 100%; text-align: center;">
                <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media5.media" class="responsive-media" alt="" loading="lazy" />
                <video
                  v-if="story.type1.type == 'video'"
                  :src="'https://admin.itsyourdayofficial.com/story/' + story.media5.media + '#t=0.001'"
                  type="video/mp4"
                  controls
                  preload="metadata"
                  style="width: 100%; max-height: 480px; object-fit: cover;"
                ></video>
              </div>

              <!-- Range Time -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" style="font-size: 16px; font-weight: normal; font-family: auto;">{{ story.rangeTime5.rangeTime }}</h2>
                </div>
              </div>

              <!-- Title -->
              <div class="elementor-element elementor-element-55ac16c zoom elementor-widget elementor-widget-heading" data-id="55ac16c" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ story.title5.title }}</h2>
                </div>
              </div>

              <!-- Description -->
              <div class="elementor-element elementor-element-7ff0c00 zoom elementor-widget elementor-widget-heading" data-id="7ff0c00" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 v-html="story.description5.description" class="elementor-heading-title elementor-size-default"></h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-2af1497 e-con-full e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-id="2af1497"
          data-element_type="container"
          id="gift"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-2fd6a04 e-con-full e-flex e-con e-child"
            data-dce-background-color="#F0EAE8"
            data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/GIFT-INNER-Minang-1-1.png"
            data-id="2fd6a04"
            data-element_type="container"
            data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
          >
            <div class="elementor-element elementor-element-cc504be fade elementor-widget elementor-widget-heading" data-id="cc504be" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">WEDDING GIFT</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-e4878de zoom elementor-widget elementor-widget-heading" data-id="e4878de" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">Kehadiran anda merupakan kado terindah bagi kami. Jika ingin memberikan tanda kasih secara cashless, gunakan menu berikut ini:</h2>
              </div>
            </div>
            <div
              data-dce-background-color="#C28846"
              class="elementor-element elementor-element-4de97b7 elementor-align-center zoom elementor-widget elementor-widget-button"
              data-id="4de97b7"
              data-element_type="widget"
              data-widget_type="button.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a class="elementor-button elementor-button-link elementor-size-sm" href="#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjEzNSIsInRvZ2dsZSI6ZmFsc2V9" target="_blank">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">Kirim Hadiah</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-5a0bc88 e-con-full e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-id="5a0bc88"
          data-element_type="container"
          id="ucapan"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-5ae6429 e-con-full e-flex e-con e-child"
            data-dce-background-color="#F0EAE8"
            data-id="5ae6429"
            data-element_type="container"
            data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
          >
            <div class="elementor-element elementor-element-5192cf3 fade elementor-widget elementor-widget-heading" data-id="5192cf3" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">UCAPAN &amp; DOA</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-43c99e8 zoom elementor-widget elementor-widget-heading" data-id="43c99e8" data-element_type="widget" data-widget_type="heading.default" style="padding-bottom: 50px;">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">Berikan ucapan dan doa terbaik untuk kedua mempelai</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-e26d27e elementor-widget elementor-widget-wpDiscuz" data-id="e26d27e" data-element_type="widget" data-widget_type="wpDiscuz.default">
              <div class="elementor-widget-container">
                <div class="wpdiscuz_top_clearing"></div>
                <div id="comments" class="comments-area">
                  <div id="respond" style="width: 0; height: 0; clear: both; margin: 0; padding: 0;"></div>
                  <div id="wpdcom" class="wpdiscuz_unauth wpd-default wpdiscuz_no_avatar wpd-layout-1 wpd-comments-open">
                    <div class="wc_social_plugin_wrapper"></div>
                    <div class="wpd-form-wrap">
                      <div class="wpd-form-head">
                        <div class="wpd-auth">
                          <div class="wpd-login"></div>
                        </div>
                      </div>
                      <div class="wpd-form wpd-form-wrapper wpd-main-form-wrapper" id="wpd-main-form-wrapper-0_0">
                        <form method="post" enctype="multipart/form-data" data-uploading="false" class="wpd_comm_form wpd_main_comm_form">
                          <div class="wpd-form-foot">
                            <div class="wpd-form-row">
                              <div class="wpd-form-col-left">
                                <div class="wpdiscuz-item wc_name-wrapper">
                                  <input id="wc_name-0_0" v-model="submit.name" required="required" aria-required="true" class="wc_name wpd-field" type="text" name="wc_name" placeholder="...*" maxlength="50" pattern=".{3,50}" title="" />
                                  <span v-if="errors.name"
                                      style="color:white; margin-top:10px; background:rgb(169, 157, 135); display: inline-block; font-size:12px;"
                                      class="badge badge-danger rounded-pill">
                                      {{ config.language === 1 ? "Please input your name" : 'Silahkan tulis nama anda' }}
                                  </span>
                                </div>
                                <div class="wpdiscuz-item wpd-field-group wpd-field-select custom_field_66dd895a02567-wrapper">
                                  <select v-model="submit.confirmation" required="required" aria-required="true" name="custom_field_66dd895a02567" class="custom_field_66dd895a02567 wpd-field wpdiscuz_select">
                                    <option value="" disabled selected>{{ config.language === 1 ? "Select Confirm Attendance" : 'Pilih Konfirmasi Kehadiran' }}</option>
                                    <option value="hadir">{{ config.language === 1 ? "Attending" : 'Hadir' }}</option>
                                    <option value="tidak">{{ config.language === 1 ? "Not Attending" : 'Tidak Hadir' }}</option>
                                  </select>
                                  <span v-if="errors.confirmation"
                                      style="color:white; margin-top:10px; background:rgb(169, 157, 135); display: inline-block; font-size:12px;"
                                      class="badge badge-danger rounded-pill">
                                      {{ config.language === 1 ? "Please confirm your attendance" : 'Harap pilih konfirmasi kehadiran anda' }}
                                  </span>
                                </div>
                                <div class="wpdiscuz-item wc-field-textarea">
                                  <div class="wpdiscuz-textarea-wrap wpd-txt">
                                    <div class="wpd-textarea-wrap">
                                      <div id="wpd-editor-char-counter-0_0" class="wpd-editor-char-counter"></div>
                                      <label style="display: none;" for="wc-textarea-0_0">Label</label>
                                      <textarea v-model="submit.comment" id="wc-textarea-0_0" placeholder="....." aria-label="....." name="wc_comment" class="wc_comment wpd-field"></textarea>
                                    </div>
                                    <div class="wpd-editor-buttons-right"></div>
                                  </div>
                                </div>                              
                              </div>
                              <div class="wpd-form-col-right">
                                <div class="wc-field-submit">
                                  <button @click.prevent="post" class="wc_comm_submit wpd_not_clicked wpd-prim-button">{{ config.language === 1 ? "Send " : 'Kirim ' }} →</button>
                                </div>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div id="wpd-threads" class="wpd-thread-wrapper">
                      <div class="wpd-thread-list">
                        <div id="wpd-comm-76_0" class="comment even thread-even depth-1 wpd-comment wpd_comment_level-1" v-for="h in hopes" :key="h.id">
                          <div class="wpd-comment-wrap wpd-blog-guest">
                            <div id="comment-76" class="wpd-comment-right">
                              <div class="wpd-comment-header">
                                <div class="wpd-comment-author">
                                  {{h.name}} 
                                  <img v-if="h.confirmation == 'hadir'" class="" src="assets/wp-content/konfirmasi/hadir.svg" alt="Konfirmasi" style="width: 16px; height: 16px; margin-left: 2px; vertical-align: -10%;" />
                                  <img v-if="h.confirmation == 'tidak'" class="" src="assets/wp-content/konfirmasi/tidak.svg" alt="Konfirmasi" style="width: 16px; height: 16px; margin-left: 2px; vertical-align: -10%;" />
                                </div>

                                <div class="wpd-space"></div>
                              </div>

                              <div class="wpd-comment-text">
                                <p v-html="h.comment"></p>
                                <div class="wpd-comment-date" title="May 18, 2025 10:49 pm">
                                  <i class="far fa-clock" aria-hidden="true"></i>
                                  {{ getElapsedTime(h.created_at) }}
                                </div>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-463a164 e-con-full e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-dce-background-image-url="assets/wp-content/uploads/2024/10/PENUTUP-Minang-1-2.png"
          data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/10/PENUTUP-Minang-1.png"
          data-id="463a164"
          data-element_type="container"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div class="has_eae_slider elementor-element elementor-element-8e5035f e-con-full e-flex e-con e-child" data-id="8e5035f" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div class="elementor-element elementor-element-1365ec9 elementor-widget elementor-widget-image" data-id="1365ec9" data-element_type="widget" data-widget_type="image.default">
              <div class="elementor-widget-container">
                <img
                  loading="lazy"
                  decoding="async"
                  width="683"
                  height="1024"
                  :src="'https://admin.itsyourdayofficial.com/foto_cover/' + client.foto_cover"
                  class="attachment-large size-large wp-image-1596"
                  alt=""
                  sizes="(max-width: 683px) 100vw, 683px"
                />
              </div>
            </div>
            <div class="elementor-element elementor-element-cab712a zoom elementor-widget elementor-widget-heading" data-id="cab712a" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">Merupakan sebuah kehormatan dan kebahagiaan bagi kami jika Bapak/Ibu /Saudara/i berkenan hadir dan memberikan doa restu bagi kami.</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-e52f757 zoom elementor-widget elementor-widget-heading" data-id="e52f757" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">Terimakasih</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-d9466be fade elementor-widget elementor-widget-heading" data-id="d9466be" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">{{ pasangan }}</h2>
              </div>
            </div>
          </div>
          <div class="has_eae_slider elementor-element elementor-element-1abb8ce e-con-full e-flex e-con e-child" data-id="1abb8ce" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div class="elementor-element elementor-element-17498a7 elementor-widget elementor-widget-html" data-id="17498a7" data-element_type="widget" data-widget_type="html.default">
              <div class="elementor-widget-container"></div>
            </div>
          </div>
          <div class="has_eae_slider elementor-element elementor-element-24f49f5 e-con-full e-flex e-con e-child" data-id="24f49f5" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div class="elementor-element elementor-element-3b821d4 elementor-widget elementor-widget-spacer" data-id="3b821d4" data-element_type="widget" data-widget_type="spacer.default">
              <div class="elementor-widget-container">
                <div class="elementor-spacer">
                  <div class="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-f1212b2 e-con-full e-flex e-con e-child"
          data-dce-background-color="#C28846"
          data-id="f1212b2"
          data-element_type="container"
          data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
        >
          <div
            class="has_eae_slider elementor-element elementor-element-fddb531 e-grid e-con-full e-con e-child elementor-sticky elementor-sticky--effects elementor-sticky--active elementor-section--handles-inside"
            data-dce-background-color="#C28846"
            data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/09/floral-2-long2.jpg"
            data-id="fddb531"
            data-element_type="container"
            data-settings='{"background_background":"classic","sticky":"bottom","sticky_offset":5,"jet_parallax_layout_list":[],"sticky_on":["desktop","tablet","mobile"],"sticky_effects_offset":0,"sticky_anchor_link_offset":0}'
            style="position: absolute; width: 456px; margin-top: 0px; margin-bottom: 0px; bottom: 5px; inset-inline-start: 1058px;"
          >
            <div
              class="elementor-element elementor-element-22c38e5 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="22c38e5"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#top" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-home" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-2c58891 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="2c58891"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#couple" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-user-friends" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-b12d689 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="b12d689"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#event" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-far-calendar-alt" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-8228523 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="8228523"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#gift" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-gift" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-26b48c2 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="26b48c2"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#ucapan" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-envelope-open-text" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="has_eae_slider elementor-element elementor-element-fddb531 e-grid e-con-full e-con e-child elementor-sticky elementor-sticky--effects elementor-sticky__spacer"
            data-dce-background-color="#C28846"
            data-dce-background-overlay-image-url="assets/wp-content/uploads/2024/09/floral-2-long2.jpg"
            data-id="fddb531"
            data-element_type="container"
            data-settings='{"background_background":"classic","sticky":"bottom","sticky_offset":5,"jet_parallax_layout_list":[],"sticky_on":["desktop","tablet","mobile"],"sticky_effects_offset":0,"sticky_anchor_link_offset":0}'
            style="visibility: visible; transition: auto; animation: auto ease 0s 1 normal none running none;"
          >
            <div
              class="elementor-element elementor-element-22c38e5 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="22c38e5"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#top" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-home" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-2c58891 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="2c58891"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#couple" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-user-friends" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-b12d689 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="b12d689"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#event" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-far-calendar-alt" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-8228523 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="8228523"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#gift" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-gift" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-26b48c2 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
              data-id="26b48c2"
              data-element_type="widget"
              data-widget_type="icon-box.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-box-wrapper">
                  <div class="elementor-icon-box-icon">
                    <a href="#ucapan" class="elementor-icon" tabindex="-1">
                      <svg aria-hidden="true" class="e-font-icon-svg e-fas-envelope-open-text" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-dce-advanced-background-color="#02010100"
          class="elementor-element elementor-element-0792083 elementor-fixed elementor-widget elementor-widget-jet-audio"
          data-id="0792083"
          data-element_type="widget"
          data-settings='{"_position":"fixed"}'
          data-widget_type="jet-audio.default"
        >
          <div class="elementor-widget-container">
            <div class="elementor-jet-audio jet-elements">
              <div class="jet-audio jet-audio--fa5-compat" data-audio-settings='{"controls":["playpause"],"startVolume":0.8,"hideVolumeOnTouchDevices":true}'>
                <span class="mejs-offscreen">Audio Player</span>
                <div id="mep_0" aria-label="Audio Player" style="width: 100%; height: 40px; min-width: 34px;">
                  <div class="mejs-inner">
                    <div class="mejs-mediaelement">
                      <mediaelementwrapper id="song">
                        <audio class="jet-audio-player" preload="metadata" src="assets/wp-content/uploads/2024/10/Minang-Instrumental-Music-GALOMBANG-by-Genta-Haramain-mp3cut.net_.mp3" width="100%" id="song_html5" loop=""></audio>
                      </mediaelementwrapper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has_eae_slider elementor-element elementor-element-cd8e31d e-con-full brand e-flex e-con e-child"
          data-dce-background-color="#F7F8F9"
          data-id="cd8e31d"
          data-element_type="container"
          data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
        >
          <div class="has_eae_slider elementor-element elementor-element-6691717 e-con-full e-flex e-con e-child" data-id="6691717" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
            <div
              class="elementor-element elementor-element-2c61570 elementor-hidden-desktop elementor-hidden-tablet elementor-hidden-mobile elementor-view-default elementor-widget elementor-widget-icon"
              data-id="2c61570"
              data-element_type="widget"
              data-widget_type="icon.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-wrapper">
                  <div class="elementor-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
                      xml:space="preserve"
                      width="3.08465in"
                      height="3.83288in"
                      style="shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality; fill-rule: evenodd; clip-rule: evenodd;"
                      viewBox="0 0 99.02 123.04"
                    >
                      <defs></defs>
                      <g id="Layer_x0020_1">
                        <metadata id="CorelCorpID_0Corel-Layer"></metadata>
                        <g id="_2948538235200">
                          <path
                            class="fil0"
                            d="M0 72.94c0,0.25 0,0.5 -0,0.75 -0,0.72 0.09,1.53 0.09,2.24l0.24 2.83c0.13,0.92 0.22,1.78 0.37,2.7 0.5,2.98 1.49,6.94 2.62,9.73l1.37 3.26c0.64,1.48 2.61,5.1 3.58,6.44l3.28 4.42 0.89 1.03c1.12,1.28 2.79,2.97 4.04,4.06l1.85 1.59 1.98 1.53c1.52,1.14 4.34,2.94 5.9,3.72 0.78,0.39 1.53,0.81 2.34,1.17 0.93,0.42 2.18,1 3.24,1.38l2.27 0.8c1.19,0.4 2.4,0.72 3.62,1.03 2.12,0.53 5.06,1.04 7.26,1.21 0.46,0.04 0.96,0.11 1.44,0.11l0.74 0.04c0.21,0.03 0.51,-0 0.74,0.03 0.28,0.04 3.57,0.04 4.02,-0.03 0.13,-0.02 0.23,-0.01 0.36,-0.01l1.76 -0.13c3.04,-0.26 6.91,-0.97 9.67,-1.85l1.74 -0.55c1.98,-0.66 4.12,-1.53 5.98,-2.47l1.49 -0.78c1.59,-0.8 4.55,-2.69 6.11,-3.89 0.59,-0.45 2.27,-1.74 2.77,-2.22 0.46,-0.44 0.97,-0.82 1.42,-1.28l0.78 -0.74c0.24,-0.18 1.45,-1.44 1.7,-1.74 0.22,-0.26 0.64,-0.66 0.91,-0.99 0.11,-0.14 0.26,-0.27 0.37,-0.41 0.12,-0.15 0.24,-0.27 0.36,-0.42l1.04 -1.26c0.85,-1.05 2.45,-3.28 3.19,-4.51l1.96 -3.41c0.1,-0.17 0.17,-0.34 0.26,-0.52 1.12,-2.25 1.94,-4.19 2.71,-6.48 1.69,-5.08 2.57,-10.08 2.57,-15.87l0 -44.46c-1.24,0 -2.37,0.22 -3.5,0.64 -3.8,1.38 -6.46,5.09 -6.46,9.33l0 33.28c0,1.09 0.03,2.23 -0.06,3.25 -0.04,0.53 -0.02,1.02 -0.1,1.57 -0.16,1.22 -0.27,2.45 -0.5,3.66 -0.35,1.8 -0.79,3.56 -1.37,5.29l-0.43 1.23 -1.23 2.93c-0.46,1.07 -1.41,2.76 -2.02,3.78 -0.91,1.52 -2.33,3.53 -3.47,4.86l-1.16 1.34c-0.27,0.3 -0.56,0.55 -0.81,0.86 -0.31,0.39 -1.46,1.44 -1.91,1.83 -1.08,0.95 -1.79,1.56 -2.98,2.45 -1.14,0.85 -2.87,2.01 -4.01,2.62 -2.08,1.1 -2.87,1.54 -5.07,2.42 -2.51,1.01 -5.12,1.73 -7.82,2.17 -0.97,0.16 -1.96,0.31 -2.94,0.39 -0.52,0.04 -1.04,0.07 -1.55,0.12 -0.49,0.04 -1.16,-0.02 -1.62,0.05 -0.33,0.05 -1.21,-0.01 -1.6,-0.02 -5.12,-0.09 -10.99,-1.46 -15.49,-3.67 -0.58,-0.29 -1.62,-0.79 -2.2,-1.13l-2.58 -1.55c-1.48,-0.99 -2.94,-2.04 -4.27,-3.22l-0.88 -0.78c-0.57,-0.47 -2.45,-2.41 -3.08,-3.16 -0.83,-0.98 -1.67,-1.97 -2.4,-3.03 -0.45,-0.66 -0.91,-1.32 -1.34,-1.99 -1.97,-3.14 -3.63,-6.75 -4.64,-10.33 -0.99,-3.53 -1.57,-7.08 -1.57,-10.92l0 -34c0.64,0 3.43,0.58 3.95,0.7 2.35,0.53 4.98,1.38 7.18,2.41l2.14 1.04c2.67,1.33 5.4,3.31 7.62,5.19l1.51 1.39 2.41 2.53c1.41,1.55 2.45,3.1 3.61,4.83 0.31,0.46 0.59,0.95 0.88,1.45l2.3 4.68c0.24,0.5 0.76,2 0.94,2.54 0.93,2.78 1.59,5.69 1.83,8.65l0.09 1.06c0.01,0.13 0.02,0.39 0.04,0.54 0.03,0.19 -0,0.39 0.02,0.58 0.05,0.33 -0.02,0.8 0.03,1.14 0.05,0.36 0.02,0.78 0.02,1.16l0 22.86 9.94 0c0,-3.23 0.07,-24.78 -0.05,-25.89l-0.09 -1.46c-0.13,-1.71 -0.37,-3.75 -0.71,-5.44 -0.77,-3.76 -1.44,-6.08 -2.81,-9.51 -0.43,-1.08 -0.91,-2.15 -1.43,-3.19l-1.48 -2.74c-0.63,-1.04 -1.25,-2.08 -1.94,-3.08 -0.06,-0.08 -0.09,-0.14 -0.15,-0.22 -1.23,-1.86 -2.19,-2.89 -3.55,-4.55 -0.21,-0.26 -0.54,-0.59 -0.73,-0.82 -0.58,-0.7 -2.72,-2.82 -3.08,-3.09 -0.08,-0.06 -0.12,-0.1 -0.19,-0.18 -0.5,-0.47 -1.31,-1.15 -1.87,-1.61 -1.46,-1.2 -3.56,-2.71 -5.16,-3.69 -0.65,-0.39 -1.28,-0.8 -1.95,-1.15l-2.81 -1.45c-3.37,-1.66 -7.25,-2.95 -10.9,-3.75 -5.95,-1.31 -9.5,-1.22 -15.58,-1.22l0 43.94z"
                          ></path>
                          <path
                            class="fil0"
                            d="M29.72 9.97c0.47,0 2.22,0.33 2.63,0.41 4.24,0.85 8.44,2.36 12.17,4.57 1.71,1.01 4.34,2.74 5.8,4.08l1 0.89c0.08,0.08 0.13,0.1 0.22,0.19l1.16 1.11c0.14,0.14 0.23,0.26 0.37,0.4 1.39,1.43 2.21,2.4 3.5,4.11 1.18,1.58 2.62,3.89 3.49,5.64 0.54,1.08 1.48,3.14 1.84,4.24 0.25,0.76 0.53,1.51 0.76,2.28 0.67,2.26 1.25,5.21 1.47,7.66l0.15 2.89 0 23.58c0,0.21 -0.06,0.69 0.09,0.69l9.88 0 0 -24.18c0,-0.5 -0.02,-0.92 -0.03,-1.41 -0,-0.15 -0.03,-0.17 -0.03,-0.31 -0.13,-2.85 -0.53,-5.96 -1.17,-8.68 -0.49,-2.1 -1.13,-4.4 -1.92,-6.41 -0.31,-0.79 -0.59,-1.58 -0.96,-2.35 -0.31,-0.65 -0.57,-1.28 -0.92,-1.98l-0.73 -1.43c-0.62,-1.24 -1.7,-2.94 -2.46,-4.12 -0.98,-1.51 -2.3,-3.23 -3.49,-4.63 -0.04,-0.05 -0.04,-0.06 -0.09,-0.11l-1.73 -1.92c-0.16,-0.2 -0.36,-0.37 -0.54,-0.55 -0.35,-0.35 -1.15,-1.21 -1.46,-1.45 -0.15,-0.12 -0.23,-0.23 -0.37,-0.35l-0.77 -0.69c-2.62,-2.38 -6.55,-5.09 -9.69,-6.68 -0.72,-0.37 -1.45,-0.75 -2.19,-1.08 -2.67,-1.19 -4.68,-1.94 -7.42,-2.74 -0.86,-0.25 -2.73,-0.72 -3.53,-0.87l-4.36 -0.72c-0.24,-0.03 -0.43,-0.06 -0.68,-0.06l0 9.97z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-6273e65 elementor-widget elementor-widget-text-editor" data-id="6273e65" data-element_type="widget" speed="1500" data-widget_type="text-editor.default">
              <div class="elementor-widget-container">
                Copyright 2025 © All rights Reserved.<br />
                Crafted with ❤ by: itsyourdayofficial.com
              </div>
            </div>
            <div
              class="elementor-element elementor-element-7eea5e6 elementor-icon-list--layout-inline elementor-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
              data-id="7eea5e6"
              data-element_type="widget"
              data-widget_type="icon-list.default"
            >
              <div class="elementor-widget-container">
                <ul class="elementor-icon-list-items elementor-inline-items">
                  <li class="elementor-icon-list-item elementor-inline-item">
                    <a href="https://itsyourdayofficial.com/" target="_blank">
                      <span class="elementor-icon-list-icon">
                        <svg aria-hidden="true" class="e-font-icon-svg e-fas-globe-asia" viewBox="0 0 496 512" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
                          ></path>
                        </svg>
                      </span>
                      <span class="elementor-icon-list-text"></span>
                    </a>
                  </li>
                  <li class="elementor-icon-list-item elementor-inline-item">
                    <a href="https://www.instagram.com/itsyourday_digitalinvitation/" target="_blank">
                      <span class="elementor-icon-list-icon">
                        <svg aria-hidden="true" class="e-font-icon-svg e-fab-instagram" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                          ></path>
                        </svg>
                      </span>
                      <span class="elementor-icon-list-text"></span>
                    </a>
                  </li>
                  <li class="elementor-icon-list-item elementor-inline-item">
                    <a
                      href="https://api.whatsapp.com/send?phone=6288290601583&amp;text=Hai%20*Itsyourday,*%2C%0ASaya%20dari%20undangan%20teman%20mau%20minta%20info%20tentang%20*Undangan%20Digital*.%0AMohon%20dibantu%20%E2%98%BA%EF%B8%8F%F0%9F%99%8F"
                      target="_blank"
                    >
                      <span class="elementor-icon-list-icon">
                        <svg aria-hidden="true" class="e-font-icon-svg e-fab-whatsapp" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                          ></path>
                        </svg>
                      </span>
                      <span class="elementor-icon-list-text"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="has_eae_slider elementor-element elementor-element-cda0202 e-con-full e-flex e-con e-parent e-lazyloaded" data-id="cda0202" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
      <div class="has_eae_slider elementor-element elementor-element-792791a e-con-full static e-flex e-con e-child" data-id="792791a" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'></div>
      <div
        class="has_eae_slider elementor-element elementor-element-a7eeaa2 e-con-full main e-flex e-con e-child"
        data-dce-background-image-url="assets/wp-content/uploads/2024/10/COVER-Minang-1.jpg"
        data-id="a7eeaa2"
        data-element_type="container"
        data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
      ></div>
    </div>
  </div>

  <div id="wpd-editor-source-code-wrapper-bg"></div>
  <div id="wpd-editor-source-code-wrapper"><textarea id="wpd-editor-source-code"></textarea><button id="wpd-insert-source-code">Insert</button><input type="hidden" id="wpd-editor-uid" /></div>

  <div class="dialog-widget dialog-lightbox-widget dialog-type-buttons dialog-type-lightbox elementor-popup-modal" id="elementor-popup-modal-135" aria-modal="true" role="document" tabindex="0" style="display: none;">
    <div class="dialog-widget-content dialog-lightbox-widget-content animated">
      <a role="button" tabindex="0" aria-label="Close" href="#" class="dialog-close-button dialog-lightbox-close-button">
        <svg class="e-font-icon-svg e-eicon-close eicon-close"><use xlink:href="#eicon-close"></use></svg>
      </a>
      <div class="dialog-message dialog-lightbox-message">
        <div
          data-elementor-type="popup"
          data-elementor-id="135"
          class="elementor elementor-135 elementor-location-popup"
          data-elementor-settings='{"entrance_animation":"fadeInRight","exit_animation":"fadeInRight","entrance_animation_duration":{"unit":"px","size":1,"sizes":[]},"prevent_close_on_background_click":"yes","prevent_close_on_esc_key":"yes","prevent_scroll":"yes","a11y_navigation":"yes","timing":[]}'
          data-elementor-post-type="elementor_library"
          style="display: block;"
        >
          <div
            class="has_eae_slider elementor-element elementor-element-17725da9 e-flex e-con-boxed e-con e-parent"
            data-id="17725da9"
            data-element_type="container"
            data-settings='{"jet_parallax_layout_list":[],"background_background":"classic"}'
          >
            <div class="e-con-inner">
              <div class="has_eae_slider elementor-element elementor-element-38b4ce0a e-con-full e-flex e-con e-child" data-id="38b4ce0a" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
                <div class="elementor-element elementor-element-c6fe6ee elementor-view-default elementor-widget elementor-widget-icon" data-id="c6fe6ee" data-element_type="widget" data-widget_type="icon.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-icon-wrapper">
                      <a class="elementor-icon" href="#elementor-action%3Aaction%3Dpopup%3Aclose%26settings%3DeyJkb19ub3Rfc2hvd19hZ2FpbiI6IiJ9">
                        <svg xmlns="http://www.w3.org/2000/svg" height="512" viewBox="0 0 512 512" width="512">
                          <g id="ESSENTIAL_UI" data-name="ESSENTIAL UI">
                            <path d="m256 0c-141.38 0-256 114.61-256 256s114.62 256 256 256 256-114.62 256-256-114.62-256-256-256z" fill=""></path>
                            <path
                              d="m120.56 400.82c153.63 0 278.17-124.54 278.17-278.16a277.77 277.77 0 0 0 -14.28-88.14 254.83 254.83 0 0 0 -128.45-34.52c-141.38 0-256 114.62-256 256a254.81 254.81 0 0 0 36.57 131.91 278.14 278.14 0 0 0 83.99 12.91z"
                              fill=""
                            ></path>
                            <path
                              d="m361.67 361.67a28.37 28.37 0 0 1 -40.11 0l-65.56-65.56-65.56 65.56a28.37 28.37 0 0 1 -40.11 0 28.37 28.37 0 0 1 0-40.11l65.56-65.56-65.56-65.56a28.37 28.37 0 0 1 0-40.11 28.37 28.37 0 0 1 40.11 0l65.56 65.56 65.56-65.56a28.37 28.37 0 0 1 40.11 0 28.37 28.37 0 0 1 0 40.11l-65.56 65.56 65.56 65.56a28.37 28.37 0 0 1 0 40.11z"
                              fill="#fff"
                            ></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-670193d5 elementor-widget elementor-widget-text-editor" data-id="670193d5" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container">
                    Silahkan kirim tanda kasih melalui nomor rekening berikut:
                  </div>
                </div>
              </div>
              <div
                class="has_eae_slider elementor-element elementor-element-78076e15 e-flex e-con-boxed e-con e-child"
                data-id="78076e15"
                data-element_type="container"
                data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
              >
                <div class="e-con-inner">
                  <div
                    class="dce-fix-background-loop elementor-element elementor-element-1a15b885 elementor-widget elementor-widget-dce-acf-repeater-v2"
                    data-id="1a15b885"
                    data-element_type="widget"
                    data-settings='{"dce_acf_repeater_format":"grid"}'
                    data-widget_type="dce-acf-repeater-v2.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="dce-acf-repeater">
                        <!-- bank 1 -->
                        <div class="dce-acf-repeater-item">
                          <div data-elementor-type="section" data-elementor-id="133" class="elementor elementor-133 dce-elementor-rendering-id-1 elementor-location-popup" data-elementor-post-type="elementor_library">
                            <div
                              class="has_eae_slider elementor-element elementor-element-72018e5b e-flex e-con-boxed e-con e-parent"
                              data-dce-background-color="#F1F1F1"
                              data-id="72018e5b"
                              data-element_type="container"
                              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
                            >
                              <div class="e-con-inner">
                                <div class="elementor-element elementor-element-a7e43e6 elementor-widget elementor-widget-heading" data-id="a7e43e6" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- seharusnya ini client.bank (nama bank)-->
                                    <h2 data-field="bank-1" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-af9823c elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                  data-id="af9823c"
                                  data-element_type="widget"
                                  data-widget_type="divider.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="elementor-divider">
                                      <span class="elementor-divider-separator"> </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-fa8e242 elementor-widget elementor-widget-heading" data-id="fa8e242" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.acc_bank (nama pemilik)-->
                                    <h2 data-field="acc_bank-1" class="elementor-heading-title elementor-size-default popup-an">—</h2>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-ee03f73 elementor-widget elementor-widget-heading" data-id="ee03f73" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.no_acc (no rekening)-->
                                    <h2 data-field="no_acc-1" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-68287e52 elementor-align-justify elementor-widget elementor-widget-dce-copy-to-clipboard"
                                  data-id="68287e52"
                                  data-element_type="widget"
                                  data-widget_type="dce-copy-to-clipboard.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="dce-clipboard-wrapper dce-clipboard-wrapper-text">
                                      <div>
                                        <button class="elementor-button elementor-size-sm" type="button" data-clipboard-target="#dce-clipboard-value-1" aria-live="polite">
                                          <span class="elementor-button-content-wrapper dce-flexbox">
                                            <span class="elementor-button-text">Copy Rekening</span>
                                          </span>
                                        </button>
                                        <input id="dce-clipboard-value-1" class="elementor-size-sm dce-clipboard-value elementor-field-textual dce-offscreen dce-form-control" data-field="clipboard_no_acc-1" type="text" value="—" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- /.e-con-inner -->
                            </div>
                          </div>
                        </div>                        
                        <!-- bank 2 -->
                        <div class="dce-acf-repeater-item">
                          <div data-elementor-type="section" data-elementor-id="133" class="elementor elementor-133 dce-elementor-rendering-id-1 elementor-location-popup" data-elementor-post-type="elementor_library">
                            <div
                              class="has_eae_slider elementor-element elementor-element-72018e5b e-flex e-con-boxed e-con e-parent"
                              data-dce-background-color="#F1F1F1"
                              data-id="72018e5b"
                              data-element_type="container"
                              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
                            >
                              <div class="e-con-inner">
                                <div class="elementor-element elementor-element-a7e43e6 elementor-widget elementor-widget-heading" data-id="a7e43e6" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- seharusnya ini client.bank (nama bank)-->
                                    <h2 data-field="bank-2" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-af9823c elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                  data-id="af9823c"
                                  data-element_type="widget"
                                  data-widget_type="divider.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="elementor-divider">
                                      <span class="elementor-divider-separator"> </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-fa8e242 elementor-widget elementor-widget-heading" data-id="fa8e242" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.acc_bank (nama pemilik)-->
                                    <h2 data-field="acc_bank-2" class="elementor-heading-title elementor-size-default popup-an">—</h2>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-ee03f73 elementor-widget elementor-widget-heading" data-id="ee03f73" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.no_acc (no rekening)-->
                                    <h2 data-field="no_acc-2" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-68287e52 elementor-align-justify elementor-widget elementor-widget-dce-copy-to-clipboard"
                                  data-id="68287e52"
                                  data-element_type="widget"
                                  data-widget_type="dce-copy-to-clipboard.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="dce-clipboard-wrapper dce-clipboard-wrapper-text">
                                      <div>
                                        <button class="elementor-button elementor-size-sm" type="button" data-clipboard-target="#dce-clipboard-value-2" aria-live="polite">
                                          <span class="elementor-button-content-wrapper dce-flexbox">
                                            <span class="elementor-button-text">Copy Rekening</span>
                                          </span>
                                        </button>
                                        <input id="dce-clipboard-value-2" class="elementor-size-sm dce-clipboard-value elementor-field-textual dce-offscreen dce-form-control" data-field="clipboard_no_acc-2" type="text" value="—" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- /.e-con-inner -->
                            </div>
                          </div>
                        </div>
                        <!-- bank 3 -->
                        <div class="dce-acf-repeater-item">
                          <div data-elementor-type="section" data-elementor-id="133" class="elementor elementor-133 dce-elementor-rendering-id-1 elementor-location-popup" data-elementor-post-type="elementor_library">
                            <div
                              class="has_eae_slider elementor-element elementor-element-72018e5b e-flex e-con-boxed e-con e-parent"
                              data-dce-background-color="#F1F1F1"
                              data-id="72018e5b"
                              data-element_type="container"
                              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
                            >
                              <div class="e-con-inner">
                                <div class="elementor-element elementor-element-a7e43e6 elementor-widget elementor-widget-heading" data-id="a7e43e6" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- seharusnya ini client.bank (nama bank)-->
                                    <h2 data-field="bank-3" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-af9823c elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                  data-id="af9823c"
                                  data-element_type="widget"
                                  data-widget_type="divider.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="elementor-divider">
                                      <span class="elementor-divider-separator"> </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-fa8e242 elementor-widget elementor-widget-heading" data-id="fa8e242" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.acc_bank (nama pemilik)-->
                                    <h2 data-field="acc_bank-3" class="elementor-heading-title elementor-size-default popup-an">—</h2>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-ee03f73 elementor-widget elementor-widget-heading" data-id="ee03f73" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.no_acc (no rekening)-->
                                    <h2 data-field="no_acc-3" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-68287e52 elementor-align-justify elementor-widget elementor-widget-dce-copy-to-clipboard"
                                  data-id="68287e52"
                                  data-element_type="widget"
                                  data-widget_type="dce-copy-to-clipboard.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="dce-clipboard-wrapper dce-clipboard-wrapper-text">
                                      <div>
                                        <button class="elementor-button elementor-size-sm" type="button" data-clipboard-target="#dce-clipboard-value-3" aria-live="polite">
                                          <span class="elementor-button-content-wrapper dce-flexbox">
                                            <span class="elementor-button-text">Copy Rekening</span>
                                          </span>
                                        </button>
                                        <input id="dce-clipboard-value-3" class="elementor-size-sm dce-clipboard-value elementor-field-textual dce-offscreen dce-form-control" data-field="clipboard_no_acc-3" type="text" value="—" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- /.e-con-inner -->
                            </div>
                          </div>
                        </div>
                        <!-- bank 4 -->
                        <div class="dce-acf-repeater-item">
                          <div data-elementor-type="section" data-elementor-id="133" class="elementor elementor-133 dce-elementor-rendering-id-1 elementor-location-popup" data-elementor-post-type="elementor_library">
                            <div
                              class="has_eae_slider elementor-element elementor-element-72018e5b e-flex e-con-boxed e-con e-parent"
                              data-dce-background-color="#F1F1F1"
                              data-id="72018e5b"
                              data-element_type="container"
                              data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
                            >
                              <div class="e-con-inner">
                                <div class="elementor-element elementor-element-a7e43e6 elementor-widget elementor-widget-heading" data-id="a7e43e6" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- seharusnya ini client.bank (nama bank)-->
                                    <h2 data-field="bank-4" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-af9823c elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                  data-id="af9823c"
                                  data-element_type="widget"
                                  data-widget_type="divider.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="elementor-divider">
                                      <span class="elementor-divider-separator"> </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-fa8e242 elementor-widget elementor-widget-heading" data-id="fa8e242" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.acc_bank (nama pemilik)-->
                                    <h2 data-field="acc_bank-4" class="elementor-heading-title elementor-size-default popup-an">—</h2>
                                  </div>
                                </div>

                                <div class="elementor-element elementor-element-ee03f73 elementor-widget elementor-widget-heading" data-id="ee03f73" data-element_type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <!-- ganti jadi client.no_acc (no rekening)-->
                                    <h2 data-field="no_acc-4" class="elementor-heading-title elementor-size-default">—</h2>
                                  </div>
                                </div>

                                <div
                                  class="elementor-element elementor-element-68287e52 elementor-align-justify elementor-widget elementor-widget-dce-copy-to-clipboard"
                                  data-id="68287e52"
                                  data-element_type="widget"
                                  data-widget_type="dce-copy-to-clipboard.default"
                                >
                                  <div class="elementor-widget-container">
                                    <div class="dce-clipboard-wrapper dce-clipboard-wrapper-text">
                                      <div>
                                        <button class="elementor-button elementor-size-sm" type="button" data-clipboard-target="#dce-clipboard-value-4" aria-live="polite">
                                          <span class="elementor-button-content-wrapper dce-flexbox">
                                            <span class="elementor-button-text">Copy Rekening</span>
                                          </span>
                                        </button>
                                        <input id="dce-clipboard-value-4" class="elementor-size-sm dce-clipboard-value elementor-field-textual dce-offscreen dce-form-control" data-field="clipboard_no_acc-4" type="text" value="—" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- /.e-con-inner -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="has_eae_slider elementor-element elementor-element-5ac031ce e-con-full e-flex e-con e-child" data-id="5ac031ce" data-element_type="container" data-settings='{"jet_parallax_layout_list":[]}'>
                <hr />
                <div class="e-con-inner">
                  <div
                    class="dce-fix-background-loop elementor-element elementor-element-1a15b885 elementor-widget elementor-widget-dce-acf-repeater-v2"
                    data-id="1a15b885"
                    data-element_type="widget"
                    data-settings='{"dce_acf_repeater_format":"grid"}'
                    data-widget_type="dce-acf-repeater-v2.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="dce-acf-repeater">
                        <!-- gift address -->
                        <div class="dce-acf-repeater-grid">
                          <div class="dce-acf-repeater-item">
                            <div data-elementor-type="section" data-elementor-id="133" class="elementor elementor-133 dce-elementor-rendering-id-1 elementor-location-popup" data-elementor-post-type="elementor_library">
                              <div
                                class="has_eae_slider elementor-element elementor-element-72018e5b e-flex e-con-boxed e-con e-parent"
                                data-dce-background-color="#F1F1F1"
                                data-id="72018e5b"
                                data-element_type="container"
                                data-settings='{"background_background":"classic","jet_parallax_layout_list":[]}'
                              >
                                <div class="e-con-inner">
                                  <div class="elementor-element elementor-element-ee03f73 elementor-widget elementor-widget-heading" data-id="ee03f73" data-element_type="widget" data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <!-- ganti jadi client.no_acc (no rekening)-->
                                      <h2 data-field="penerima" class="elementor-heading-title elementor-size-default">
                                      </h2>
                                    </div>
                                  </div>

                                  <div
                                    class="elementor-element elementor-element-af9823c elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                    data-id="af9823c"
                                    data-element_type="widget"
                                    data-widget_type="divider.default"
                                  >
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
                                        <span class="elementor-divider-separator"> </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="elementor-element elementor-element-ee03f73 elementor-widget elementor-widget-heading" data-id="ee03f73" data-element_type="widget" data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <!-- ganti jadi client.no_acc (no rekening)-->
                                      <h2 data-field="alamat" class="elementor-heading-title elementor-size-default">
                                      </h2>
                                    </div>
                                  </div>

                                  <div
                                    class="elementor-element elementor-element-68287e52 elementor-align-justify elementor-widget elementor-widget-dce-copy-to-clipboard"
                                    data-id="68287e52"
                                    data-element_type="widget"
                                    data-widget_type="dce-acf-repeater-v2.default"
                                  >
                                    <div class="elementor-widget-container">
                                      <div class="dce-clipboard-wrapper dce-clipboard-wrapper-text">
                                        <div>
                                          <button class="elementor-button elementor-size-sm" type="button" data-clipboard-target="#copy-gift-address" aria-live="polite">
                                            <span class="elementor-button-content-wrapper dce-flexbox">
                                              <span class="elementor-button-text">Copy Alamat</span>
                                            </span>
                                          </button>
                                          <input
                                            id="copy-gift-address"
                                            class="elementor-size-sm dce-clipboard-value elementor-field-textual dce-offscreen dce-form-control"
                                            data-field="clipboard_address"
                                            type="text"
                                            value="—" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- /.e-con-inner -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <transition name="slide-fade">
      <div id="snackbar" v-if="snackbar">{{ config.language === 1 ? 'Your confirmation has been saved, thank you.' : messageSnackBar }}</div>
  </transition>
</template>

<script setup>
import { ref, computed, onServerPrefetch, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHead } from '@unhead/vue';

// Mulai dengan nilai null sehingga komponen tahu data belum ada.
const clientForServer = ref(null);

// Dapatkan akses ke route dan router.
const route = useRoute();
const router = useRouter();

// Dapatkan instance global (misalnya untuk menggunakan $api yang sudah disuntikkan).
const { proxy } = getCurrentInstance();

/*
  Gunakan useHead dengan computed properties untuk mengatur meta tags.
  Nilai default kosong sampai data API didapat.
*/
// === URL OG image 1200×630 JPEG (via proxy resize), dengan fallback ===
    const ogImageUrl = computed(() => {
    const original =
      clientForServer.value && clientForServer.value.foto_cover
        ? `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`
        : null;

    // 1200x630 (1.91:1) + smart crop agar pusat perhatian tetap tampil rapi
    return original
      ? `https://images.weserv.nl/?url=${encodeURIComponent(original.replace(/^https?:\/\//, ''))}&w=600&h=550&fit=cover&a=center&output=jpg&q=85`
      : `https://itsyourdayofficial.com/og/default-1200x630.jpg`; // pastikan file ini ada & publik
  });


  // === Meta OG (tetap 1200x630 untuk WhatsApp) ===
  useHead({
    title: computed(() => {
      if (clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria) {
        return clientForServer.value.hajat === 'wanita'
          ? `Wedding Invitation ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : `Wedding Invitation ${clientForServer.value.nama_pria} & ${clientForServer.value.nama_wanita}`;
      }
      return "";
    }),
    meta: [
      { key: "og:title", property: "og:title", content: computed(() =>
        clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria
          ? `Wedding of ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : ""
      )},
      { key: "og:description", property: "og:description", content: computed(() =>
        clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria
          ? `Mohon doa dan restunya atas pernikahan kami ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : ""
      )},
      { key: "og:url", property: "og:url", content: "https://admin.itsyourdayofficial.com" },
      { key: "og:type", property: "og:type", content: "website" },

      // ==== OG image (WA / FB) ====
      { key: "og:image", property: "og:image", content: ogImageUrl },
      { key: "og:image:width",  property: "og:image:width",  content: "1200" },
      { key: "og:image:height", property: "og:image:height", content: "630" },
      { key: "og:image:type",   property: "og:image:type",   content: "image/jpeg" },
    ],
    link: [
      {
        rel: "icon",
        href: computed(() => {
          if (clientForServer.value && clientForServer.value.foto_cover) {
            return `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`;
          }
          return "";
        }),
      },
    ],
  });

/*
  Fungsi fetchclientData() melakukan API call untuk mengambil data berdasarkan route.
  Kami menangani parameter 'to' dengan cara:
  1. Mengambil nilai dari route (tersedia baik pada SSR maupun client-side).
  2. Decode parameter tersebut.
  3. Validasi menggunakan regex: format yang valid adalah hanya alfanumerik dengan tanda strip sebagai pemisah (misalnya, "Juju-Dan-Suami").
     Jika tidak memenuhi (misalnya hanya satu kata atau mengandung spasi/karakter lain), maka parameter dikosongkan.
  4. Menentukan URL template berdasarkan lingkungan (SSR atau client).
*/
async function fetchclientData() {
  let toParam = route.query.to || "";  
//   console.log("Param to:", toParam);
  if (toParam) {
    const decodedTo = decodeURIComponent(toParam);
    // Regex valid: minimal dua kata (alfanumerik) yang dipisahkan oleh strip, tanpa spasi atau karakter khusus lain.
    const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
    if (!validDBPattern.test(decodedTo)) {
      // Bila tidak sesuai, parameter dikosongkan untuk API request.
      toParam = "";
    } else {
      // Jika valid, gunakan nilai decoded.
      toParam = decodedTo;
    }
  }

  // Jika window tidak tersedia (SSR), gunakan URL fallback.
  const templateUrl =
    typeof window !== "undefined"
      ? window.location.origin + "/"
      : "	https://minang.itsyourdayofficial.com/"; //host
    // : "http://localhost:8080/";  //local

  try {
    // console.log("Memulai fetch API dengan slug: ", route.params.slug);
    // console.log("Template URL:", templateUrl);
    const response = await proxy.$api.get('/' + route.params.slug, {
      params: {
        to: toParam,
        template: templateUrl,
      },
    });
    if (response.data.data) {
      clientForServer.value = response.data.data;
    } else {
      router.push({ name: 'NotFoundPage' });
    }
  } catch (error) {
    console.error("Error fetching clientForServer data:", error);
  }
}

/*
  onServerPrefetch() hanya dipanggil saat SSR.
  Server akan menunggu Promise yang dikembalikan sehingga data sudah tersedia sebelum render.
*/
onServerPrefetch(async () => {
  await fetchclientData();
});

/*
  onMounted() adalah fallback untuk rendering client-side.
  Jika data belum ada (misalnya karena navigasi client-side), API dipanggil ulang.
*/
onMounted(async () => {
  if (!clientForServer.value) {
    await fetchclientData();
  }
});
</script>

<script>
  import moment from "moment";
  import VueHorizontal from "vue-horizontal";
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }
  export default {
    components: {
      // Modal,
      VueHorizontal,
    },
    data() {
      return {
        client: {},
        accObserver: null,
        fallbackName: "",
        guest: {},
        moment: moment,
        date: "",
        config: {},
        now: 0,
        count: 0,
        gallery: [],
        currentSlideIndex: 0,
        slideshowInterval: null,
        currentIndex: 0,
        lightboxVisible: false,
        Lightbox: null,
        hasPrev: false,
        hasNext: true,
        autoScrollInterval: null, // untuk menyimpan ID interval auto-scroll
        showGallery: false,
        interval: null,
        name: "",
        picked: "",
        jumlah: "",
        story: {
          title1: "",
          description1: "",
          date1: "",
          month1: "",
          year1: "",
          media1: "",
          type1: "",
          order1: "",
          rangeTime1: "",
          title2: "",
          description2: "",
          date2: "",
          month2: "",
          year2: "",
          media2: "",
          type2: "",
          order2: "",
          rangeTime2: "",
          title3: "",
          description3: "",
          date3: "",
          month3: "",
          year3: "",
          media3: "",
          type3: "",
          order3: "",
          rangeTime3: "",
          title4: "",
          description4: "",
          date4: "",
          month4: "",
          year4: "",
          media4: "",
          type4: "",
          order4: "",
          rangeTime4: "",
          title5: "",
          description5: "",
          date5: "",
          month5: "",
          year5: "",
          media5: "",
          type5: "",
          order5: "",
          rangeTime5: "",
        },
        hopes: {},
        submit: {
            client_id: '',
            name: '',
            comment: '',
            confirmation: '',
        },
        snackbar: false,
        messageSnackBar: 'Konfirmasi anda sudah tersimpan, terima kasih.',
        errors: {},
      };
    },
    mounted() {
      import("vue-easy-lightbox")
        .then((module) => {
          this.Lightbox = module.default;
        })
        .catch((err) => {
          console.error("Gagal memuat vue-easy-lightbox:", err);
        });

      window.addEventListener("scroll", debounce(this.checkScroll, 100), { passive: true });

      let rawToParam = this.getOriginalQueryParam("to") || "";
      if (rawToParam) {
        // decode untuk validasi
        const decodedTo = decodeURIComponent(rawToParam);
        /*  
                Kita gunakan regex untuk menentukan format yang valid.
                Format valid adalah:
                    - Satu atau lebih kata (hanya A-Z atau a-z atau angka) 
                    - Dipisah dengan tanda strip (misalnya: Kata1-Kata2 atau kata1-kata2-kata3)
                Contoh:
                    • "Juju-Dan-Suami" → valid.
                    • "Desty" (hanya 1 kata) → tidak valid.
                    • "Ibu. Desty - Suami" → tidak valid karena mengandung spasi, titik, atau karakter lain.
                    Jika tidak valid, simpan fallbackName dan kosongkan parameter untuk API
                */
        const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
        if (!validDBPattern.test(decodedTo)) {
          // Simpan nilai fallback agar computed property bisa menggunakannya
          this.fallbackName = decodedTo;
          // Jika tidak memenuhi pola, gunakan nilai kosong untuk request API.
          rawToParam = "";
        }
      }

      const isBlank = (v) => v === null || v === undefined || String(v).trim() === "";
      const nv = (v) => (isBlank(v) ? "—" : String(v));
      // Elementor bisa memindahkan node, jadi pakai dokumen penuh
      const getRoot = () => document;

      // Mengubah HTML menjadi teks polos (hapus <p>, <br>, dsb) lalu trim spasi
      const htmlToPlain = (html) => {
        if (html == null) return '';
        // Ganti <br> menjadi baris baru agar tetap terbaca
        const normalized = String(html).replace(/<br\s*\/?>/gi, '\n');
        const tmp = document.createElement('div');
        tmp.innerHTML = normalized;
        const text = tmp.textContent || tmp.innerText || '';
        return text.replace(/\s+\n/g, '\n').replace(/\n{2,}/g, '\n').trim();
      };


      // === UI: penerima & gift address ===
      const updateRecipientAndAddressUI = () => {
        const root = typeof getRoot === 'function' ? getRoot() : document;
        const isEmpty = (v) => (typeof isBlank === 'function' ? isBlank(v) : (v == null || String(v).trim() === ''));

        // --- Tentukan label penerima berdasar query recipient=wanita|pria; default 'wanita' lalu fallback ke pasangannya ---
        const rawPref = (this.getOriginalQueryParam && this.getOriginalQueryParam('recipient')) || '';
        const pref = String(rawPref).toLowerCase().trim() === 'pria' ? 'pria' : 'wanita';

        const namaWanita = this.client?.nama_wanita ?? '';
        const namaPria   = this.client?.nama_pria ?? '';

        let recipientLabel = '';
        if (pref === 'wanita') {
          recipientLabel = !isEmpty(namaWanita) ? namaWanita : (!isEmpty(namaPria) ? namaPria : '');
        } else {
          recipientLabel = !isEmpty(namaPria) ? namaPria : (!isEmpty(namaWanita) ? namaWanita : '');
        }

        // Jika Anda ingin selalu menampilkan KEDUA nama ketika keduanya ada, gunakan baris ini sebagai pengganti:
        recipientLabel = [namaWanita, namaPria].filter((x) => !isEmpty(x)).join(' - ') || '';

        // --- Tulis ke <h2 data-field="penerima"> dengan tampilan lebih eye-catching ---
        const penerimaNodes = root.querySelectorAll('[data-field="penerima"]');
        penerimaNodes.forEach((h2) => {
          if (isEmpty(recipientLabel)) {
            h2.innerHTML = '<span class="ui-label">Penerima:</span>';
          } else {
            h2.innerHTML = `
              <span class="ui-label">Penerima:</span><br/>
              <span class="ui-value">${recipientLabel}<br/></span>
            `;
          }
        });

        // --- Sanitasi gift_address agar TIDAK ada tag <p> & sejenis ---
        const giftAddress = this.client?.gift_address ?? '';
        const cleanAddress = htmlToPlain(giftAddress);

        // --- Tulis alamat & kontrol visibilitas container besar ---
        const alamatNodes = root.querySelectorAll('[data-field="alamat"]');
        alamatNodes.forEach((h2) => {
          if (isEmpty(cleanAddress)) {
            h2.innerHTML = '<span class="ui-label">Alamat:</span>';
          } else {
            h2.innerHTML = `
              <span class="ui-label">Alamat:</span><br/>
              <span class="ui-value">${cleanAddress.replace(/\n/g, '<br/>')}</span>
            `;
          }
        });

        // --- Hide/Show container besar jika gift_address kosong ---
        const containers = root.querySelectorAll('[data-id="5ac031ce"], .elementor-element-5ac031ce');
        const hideAll = isEmpty(cleanAddress);
        containers.forEach((el) => {
          el.style.display = hideAll ? 'none' : '';
        });
        console.log('[UI] penerima+alamat =>',
          `recipient="${recipientLabel || '(kosong)'}", gift_address="${cleanAddress || '(kosong)'}",`,
          hideAll ? 'HIDE container 5ac031ce' : 'SHOW container 5ac031ce'
        );

        // --- Sinkronkan nilai clipboard untuk "Copy Alamat" (tanpa <p>) ---
        const clipInputAddr = root.querySelector('#copy-gift-address');
        if (clipInputAddr) {
          clipInputAddr.value = cleanAddress || '—';
        }

        // --- (Opsional) Hide blok copy jika alamat kosong ---
        const copyAddrBlock = root.querySelector('[data-id="68287e52"], .elementor-element-68287e52');
        if (copyAddrBlock && copyAddrBlock.matches('.alamat-container')) {
            copyAddrBlock.style.display = isEmpty(cleanAddress) ? 'none' : '';
        }



      };

      // Ambil nilai TAMPIL per-set (punya fallback utk set 2-4 seperti script Anda semula)
      const getSetValues = (i) => {
        const bankKey = i === 1 ? "bank" : `bank${i}`;
        const accBankKey = i === 1 ? "acc_bank" : `acc_bank${i}`;
        const noAccKey = i === 1 ? "no_acc" : `no_acc${i}`;

        const bank = this.client[bankKey];
        const acc_bank = accBankKey in this.client ? this.client[accBankKey] : this.client["acc_bank"];
        const no_acc = noAccKey in this.client ? this.client[noAccKey] : this.client["no_acc"];
        return { bank, acc_bank, no_acc };
      };

      // Sembunyikan/ tampilkan wrapper set-i berdasarkan NILAI MENTAH (tanpa fallback)
      const hideBySet = (i) => {
        // Ambil nilai mentah untuk logika hide
        const rawBank = i === 1 ? this.client.bank : this.client[`bank${i}`];
        const rawAcc = i === 1 ? this.client.acc_bank : this.client[`acc_bank${i}`];
        const rawNo = i === 1 ? this.client.no_acc : this.client[`no_acc${i}`];

        const shouldHide = isBlank(rawBank) && isBlank(rawAcc) && isBlank(rawNo);

        const root = getRoot();
        // Kumpulkan elemen-elemen 1 set untuk menemukan wrapper-nya
        const setEls = root.querySelectorAll(
          `[data-field="bank-${i}"],
         [data-field="acc_bank-${i}"],
         [data-field="no_acc-${i}"],
         #dce-clipboard-value-${i},
         [data-field="clipboard_no_acc-${i}"]`
        );

        const wrappers = new Set();
        setEls.forEach((el) => {
          const w = el.closest(".dce-acf-repeater-item");
          if (w) wrappers.add(w);
        });

        wrappers.forEach((w) => {
          w.style.display = shouldHide ? "none" : "";
        });

        // Log sederhana
        console.log(`[UI] set-${i} visibility =>`, shouldHide ? "hidden" : "shown");
      };

      // Tulis 1 set (i=1..4) & atur visibilitasnya
      const writeSet = (i) => {
        const root = getRoot();
        const { bank, acc_bank, no_acc } = getSetValues(i);

        const elsBank = root.querySelectorAll(`[data-field="bank-${i}"]`);
        const elsAcc = root.querySelectorAll(`[data-field="acc_bank-${i}"]`);
        const elsNo = root.querySelectorAll(`[data-field="no_acc-${i}"]`);
        const elsClip = root.querySelectorAll(`#dce-clipboard-value-${i}, [data-field="clipboard_no_acc-${i}"]`);

        // Debug hitungan elemen supaya tahu selector kena atau tidak
        console.log(`[DEBUG] set-${i} matches: bank=${elsBank.length}, acc_bank=${elsAcc.length}, no_acc=${elsNo.length}, clip=${elsClip.length}`);

        elsBank.forEach((el) => {
          const v = nv(bank);
          if (el.textContent !== v) {
            el.textContent = v;
            console.log(`[UI] bank-${i} =>`, v);
          }
        });

        elsAcc.forEach((el) => {
          const v = nv(acc_bank);
          if (el.textContent !== v) {
            el.textContent = v;
            console.log(`[UI] acc_bank-${i} =>`, v);
          }
        });

        elsNo.forEach((el) => {
          const v = nv(no_acc);
          if (el.textContent !== v) {
            el.textContent = v;
            console.log(`[UI] no_acc-${i} =>`, v);
          }
        });

        elsClip.forEach((el) => {
          const v = nv(no_acc);
          if (el.value !== undefined) {
            if (el.value !== v) {
              el.value = v;
              console.log(`[UI] clipboard_no_acc-${i} =>`, v);
            }
          } else if (el.textContent !== v) {
            el.textContent = v;
            console.log(`[UI] clipboard_no_acc-${i} (text) =>`, v);
          }
        });

        // TERAKHIR: atur visibilitas wrapper set-i
        hideBySet(i);
      };

      // Tulis semua set sekaligus
      const writeAllSets = () => {
        const rows = [];
        for (let i = 1; i <= 4; i++) {
          const v = getSetValues(i);
          rows.push({ set: i, bank: v.bank, acc_bank: v.acc_bank, no_acc: v.no_acc });
          writeSet(i); // ini juga otomatis hide/show per set
        }
        console.table(rows);
      };

      // Delegasi copy (tetap)
      const onClickCopyDelegate = async (e) => {
        const btn = e.target.closest('[data-clipboard-target^="#dce-clipboard-value-"], [data-clipboard-target="#copy-gift-address"]');
        if (!btn) return;

        const targetSelector = btn.getAttribute("data-clipboard-target");
        const target = document.querySelector(targetSelector);
        if (!target) {
          console.log("[DEBUG] copy: target tidak ditemukan =>", targetSelector);
          return;
        }

        // Pastikan target per-set diisi terbaru
        const m = targetSelector.match(/dce-clipboard-value-(\d+)/);
        if (m) writeSet(Number(m[1]));
        else writeAllSets();

        const text = target.value ?? target.textContent ?? "";
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
          } else {
            if (target.select) {
              target.select();
              target.setSelectionRange(0, text.length);
              document.execCommand("copy");
            } else {
              const temp = document.createElement("input");
              temp.style.position = "absolute";
              temp.style.left = "-9999px";
              temp.value = text;
              document.body.appendChild(temp);
              temp.select();
              document.execCommand("copy");
              document.body.removeChild(temp);
            }
          }
          const label = btn.querySelector(".elementor-button-text");
          const old = label ? label.textContent : "Copy Rekening";
          if (label) label.textContent = "Copied";
          btn.disabled = true;
          setTimeout(() => {
            if (label) label.textContent = old;
            btn.disabled = false;
          }, 1500);
          console.log("[DEBUG] copied =>", text);
        } catch (err) {
          console.warn("[DEBUG] copy gagal:", err);
        }
      };

      document.addEventListener("click", onClickCopyDelegate);
      this._unbindCopyDelegate = () => document.removeEventListener("click", onClickCopyDelegate);

      // ==== Observer DOM (aktif setelah data siap) ====
      let rafPending = false;
      this.accObserver = new MutationObserver(() => {
        if (!this._dataReady) return;
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(() => {
          rafPending = false;
          writeAllSets();
          updateRecipientAndAddressUI();
        });
      });
      this.accObserver.observe(document.body, { childList: true, subtree: true });

      // ---- Ambil data kamu seperti biasa ----
      const template = window.location.origin + "/";
      const slug = this.$route.params.slug;

      console.group("[API] Fetch client");
      console.info("GET", `/${slug}`, { to: this.getOriginalQueryParam("to") || "", template });
      const t0 = performance.now();

      // Lakukan request API dengan parameter yang telah divalidasi (jika valid, rawToParam berisi string valid,
      // jika tidak valid, rawToParam akan kosong dan fallbackName akan terisi)
      this.$api
        .get("/" + slug, { params: { to: rawToParam, template } })
        .then((response) => {
          const t1 = performance.now();
          console.info("✓ Response status:", response.status, response.statusText);
          // Pastikan payload ada
          const data = response && response.data && response.data.data;

          if (!data) {
            console.error("✗ data.data TIDAK ADA. Payload penuh:", response.data);
            console.groupEnd();
            this.$router.push({ name: "NotFoundPage" });
            return;
          }

          // 1) Assign dulu
          Object.assign(this.client, data);

          // 2) Tandai data siap (observer boleh menulis)
          this._dataReady = true;

          // 3) Log state dan CETAK satu tabel
          console.info("State client terisi:", {
            bank: this.client.bank,
            bank2: this.client.bank2,
            bank3: this.client.bank3,
            bank4: this.client.bank4,
            acc_bank: this.client.acc_bank,
            acc_bank2: this.client.acc_bank2,
            acc_bank3: this.client.acc_bank3,
            acc_bank4: this.client.acc_bank4,
            no_acc: this.client.no_acc,
            no_acc2: this.client.no_acc2,
            no_acc3: this.client.no_acc3,
            no_acc4: this.client.no_acc4,
          });

          const rows = [];
          for (let i = 1; i <= 4; i++) {
            const v = {
              bank: i === 1 ? this.client.bank : this.client[`bank${i}`],
              acc_bank: i === 1 ? this.client.acc_bank : this.client[`acc_bank${i}`] ?? this.client.acc_bank,
              no_acc: i === 1 ? this.client.no_acc : this.client[`no_acc${i}`] ?? this.client.no_acc,
            };
            rows.push({ set: i, ...v });
          }
          console.table(rows);
          console.debug("Durasi:", (t1 - t0).toFixed(1), "ms");

          // 4) Tulis UI sekarang
          writeAllSets();
          updateRecipientAndAddressUI();

          var currentUrl = window.location.href;
          this.guest = response.data.data;
          if (currentUrl.includes(this.client.template) == false) {
            this.$router.push({ name: "NotFoundPage" });
          }
          if (response.data.data.config[0].countdown == 1) {
            this.date = moment(response.data.data.tgl_resepsi).format("MMMM DD, YYYY hh:mm:ss a");
          } else if (this.client.tgl_unduh_mantu !== null) {
            this.date = moment(response.data.data.tgl_unduh_mantu).format("MMMM DD, YYYY hh:mm:ss a");
          } else {
            this.date = moment(response.data.data.tgl_akad).format("MMMM DD, YYYY hh:mm:ss a");
          }
          this.config = response.data.data.config[0];
          this.timer_loop();
          this.modifiedDate = Math.trunc(Date.parse(this.date) / 1000);
          this.gallery = response.data.data.gallery;
          this.pages = this.gallery.length;
          // Update hasNext property based on whether gallery has items
          this.hasNext = this.gallery.length > 1;
          this.startSlideshow();
          this.story.title1 = response.data.data.story[0];
          this.story.description1 = response.data.data.story[0];
          this.story.date1 = response.data.data.story[0];
          this.story.month1 = response.data.data.story[0];
          this.story.year1 = response.data.data.story[0];
          this.story.media1 = response.data.data.story[0];
          this.story.type1 = response.data.data.story[0];
          this.story.order1 = response.data.data.story[0];
          this.story.rangeTime1 = response.data.data.story[0];
          this.story.title2 = response.data.data.story[1];
          this.story.description2 = response.data.data.story[1];
          this.story.date2 = response.data.data.story[1];
          this.story.month2 = response.data.data.story[1];
          this.story.year2 = response.data.data.story[1];
          this.story.media2 = response.data.data.story[1];
          this.story.type2 = response.data.data.story[1];
          this.story.order2 = response.data.data.story[1];
          this.story.rangeTime2 = response.data.data.story[1];
          this.story.title3 = response.data.data.story[2];
          this.story.description3 = response.data.data.story[2];
          this.story.date3 = response.data.data.story[2];
          this.story.month3 = response.data.data.story[2];
          this.story.year3 = response.data.data.story[2];
          this.story.media3 = response.data.data.story[2];
          this.story.type3 = response.data.data.story[2];
          this.story.order3 = response.data.data.story[2];
          this.story.rangeTime3 = response.data.data.story[2];
          this.story.title4 = response.data.data.story[3];
          this.story.description4 = response.data.data.story[3];
          this.story.date4 = response.data.data.story[3];
          this.story.month4 = response.data.data.story[3];
          this.story.year4 = response.data.data.story[3];
          this.story.media4 = response.data.data.story[3];
          this.story.type4 = response.data.data.story[3];
          this.story.order4 = response.data.data.story[3];
          this.story.rangeTime4 = response.data.data.story[3];
          this.story.title5 = response.data.data.story[4];
          this.story.description5 = response.data.data.story[4];
          this.story.date5 = response.data.data.story[4];
          this.story.month5 = response.data.data.story[4];
          this.story.year5 = response.data.data.story[4];
          this.story.media5 = response.data.data.story[4];
          this.story.type5 = response.data.data.story[4];
          this.story.order5 = response.data.data.story[4];
          this.story.rangeTime5 = response.data.data.story[4];
          this.submit.client_id = this.client.id;
          this.picked = this.config.language === 1 ? "Yes, I would love to attend" : "Iya, Saya akan Hadir";
          this.$refs.horizontal.scrollToIndex(1);
          // Mulai auto-scroll jika gallery terlihat
          if (this.showGallery) {
            this.startAutoScroll();
          }
          this.startAutoScrollStoryImage();
          this.$api.get('comment/' + this.client.id)
            .then(response => {
                this.hopes = response.data.data;
            })
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },

    computed: {
      backgroundStyle() {
        if (this.client.foto_cover) {
          return {
            backgroundImage: `url('https://admin.itsyourdayofficial.com/foto_cover/${this.client.foto_cover}')`,
            backgroundPosition: "center center",
            backgroundSize: "cover",
          };
        }
        return {};
      },

      pasangan() {
        // Pastikan data client sudah lengkap sebelum mengembalikan string
        if (this.client && this.client.nama_pria && this.client.nama_wanita && this.client.hajat) {
          if (this.client.hajat === "wanita") {
            return `${this.client.nama_wanita} & ${this.client.nama_pria}`;
          } else {
            return `${this.client.nama_pria} & ${this.client.nama_wanita}`;
          }
        }
        // Jika data belum lengkap, kembalikan string kosong
        return "";
      },

      namaPertama() {
        return this.client.hajat === "wanita" ? this.client.nama_wanita : this.client.nama_pria;
      },
      namaKedua() {
        return this.client.hajat === "wanita" ? this.client.nama_pria : this.client.nama_wanita;
      },

      namaTamu() {
        // Jika guest.nama tersedia, gunakan itu
        if (this.guest && this.guest.nama) {
          return this.guest.nama;
        }
        // Jika tidak, gunakan fallbackName
        return this.fallbackName || "";
      },

      seconds() {
        const result = (this.modifiedDate - this.now) % 60;
        return result < 0 ? 0 : result;
      },
      minutes() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60) % 60;
        return result < 0 ? 0 : result;
      },
      hours() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60) % 24;
        return result < 0 ? 0 : result;
      },
      days() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60 / 24);
        return result < 0 ? 0 : result;
      },
      modifiedDate: function () {
        return Math.trunc(Date.parse(this.date) / 1000);
      },

      currentBackgroundStyle() {
        if (this.gallery.length === 0) return {};
        return {
          backgroundImage: `url('https://admin.itsyourdayofficial.com/gallery/${this.gallery[this.currentSlideIndex].file}')`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          transition: "background-image 1s ease-in-out",
        };
      },
      imageList() {
        return this.gallery.map((item) => "https://admin.itsyourdayofficial.com/gallery/" + item.file);
      },

      formattedHashtag() {
        const capitalize = (str) => {
          if (!str) return "";
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        const firstName = this.client.hajat === "wanita" ? this.client.nama_wanita : this.client.nama_pria;
        const secondName = this.client.hajat === "wanita" ? this.client.nama_pria : this.client.nama_wanita;

        return `#${capitalize(firstName)}${capitalize(secondName)}`;
      },
      confirmationText() {
        if (this.config.language === 1) {
          return "Help us prepare the event better by filling out the <b>Attendance Confirmation</b> form below:";
        } else {
          return "Bantu kami mempersiapkan acara lebih baik dengan mengisi form <b>Konfirmasi Kehadiran</b> berikut:";
        }
      },
    },
    beforeUnmount() {
      // Clean up all intervals and timeouts
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
      }
      if (this.interval) {
        clearInterval(this.interval);
      }

      if (this.accObserver) {
        this.accObserver.disconnect();
        this.accObserver = null;
      }

      window.removeEventListener("scroll", this.checkScroll);
    },
    methods: {
      getOriginalQueryParam(paramName) {
        // Pastikan hanya mencoba mengakses window jika ada
        if (typeof window === "undefined") return null;
        const queryString = window.location.search;
        const regex = new RegExp(`[?&]${paramName}=([^&]+)`);
        const matches = regex.exec(queryString);
        return matches && matches.length > 1 ? matches[1] : null;
      },
      timer_loop() {
        this.count++;
        this.now = Math.trunc(new Date().getTime() / 1000);
        if (this.count < 200 && this.modifiedDate > this.now) {
          setTimeout(this.timer_loop, 1000);
        } else {
          this.count = 0;
        }
      },

      startSlideshow() {
        if (this.gallery.length < 2) return;
        this.slideshowInterval = setInterval(() => {
          this.currentSlideIndex = (this.currentSlideIndex + 1) % this.gallery.length;
        }, 3000); // Ganti setiap 2 detik
      },

      generateCalendarLink() {
        const linkText = "Pernikahan " + this.client.nama_wanita + " dan " + this.client.nama_pria;
        const startDate = moment(this.client.tgl_resepsi).format("YYYYMMDD");
        const startTime = moment(this.client.tgl_resepsi).format("HHmmss");
        const endTime = moment(this.client.tgl_resepsi_selesai).format("HHmmss");
        return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(linkText)}&details&dates=${startDate}T${startTime}/${startDate}T${endTime}&location`;
      },
      openLightbox(index) {
        this.currentIndex = index;
        this.lightboxVisible = true;
      },
      closeLightbox() {
        this.lightboxVisible = false;
      },

      prev(event) {
        if (this.$refs.horizontal && typeof this.$refs.horizontal.prev === "function") {
          this.$refs.horizontal.prev(event);
        } else {
          console.error("Horizontal ref or prev method is not defined");
        }
      },
      next(event) {
        if (this.$refs.horizontal && typeof this.$refs.horizontal.next === "function") {
          this.$refs.horizontal.next(event);
        } else {
          console.error("Horizontal ref or next method is not defined");
        }
      },

      onScroll({ hasPrev, hasNext }) {
        this.hasPrev = hasPrev;
        this.hasNext = hasNext;
      },
      checkScroll() {
        const galleryElement = document.querySelector(".show-gallery");
        if (galleryElement) {
          const rect = galleryElement.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
          this.showGallery = isVisible;
          if (isVisible && !this.autoScrollInterval) {
            this.startAutoScroll();
          } else if (!isVisible && this.autoScrollInterval) {
            clearInterval(this.autoScrollInterval);
            this.autoScrollInterval = null;
          }
        }
      },
      startAutoScroll() {
        // Clear existing interval
        if (this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
        }
        this.autoScrollInterval = setInterval(() => {
          if (this.hasNext) {
            this.next({ stopPropagation: () => {} });
          } else {
            this.$refs.horizontal.scrollToIndex(0);
          }
        }, 5000);
      },

      startAutoScrollStoryImage() {
        const wrapper = this.$refs.carouselWrapper;
        let position = 0;
        const speed = 0.5;

        function animate() {
          position -= speed;
          wrapper.style.transform = `translate3d(${position}px, 0, 0)`;
          wrapper.style.transitionDuration = "0ms";

          const totalWidth = wrapper.scrollWidth / 2; // karena kita duplikat
          if (Math.abs(position) >= totalWidth) {
            position = 0; // reset saat set pertama selesai
          }

          requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
      },

      handleSubmit() {
        const form = event.target.closest("form");
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        let message = `Hai, saya ${this.name} ingin konfirmasi kehadiran undangan pernikahan bahwa ${this.picked}.`;

        // Tambahkan jumlah jika hadir
        if (this.picked === "Iya, Saya akan Hadir" || this.picked === "Yes, I would love to attend") {
          message += ` Jumlah yang hadir adalah ${this.jumlah}.`;
        }

        message += " Terima kasih";

        const url = `https://api.whatsapp.com/send?phone=${this.client.wa_number}&text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
      },
      getElapsedTime(created_at) {
            const currentTime = Math.floor(Date.now() / 1000); // Waktu saat ini dalam detik
            const createdAt = Math.floor(new Date(created_at).getTime() / 1000); // Waktu yang diberikan dalam detik

            const timeDifference = currentTime - createdAt;

            if (this.config.language === 1) {
                if (timeDifference < 60) {
                    return 'A few seconds ago'; 
                } else if (timeDifference < 3600) {
                    const minutes = Math.floor(timeDifference / 60);
                    return `${minutes} minutes ago`;
                } else if (timeDifference < 86400) {
                    const hours = Math.floor(timeDifference / 3600);
                    const remainingMinutes = Math.floor((timeDifference % 3600) / 60);
                    return `${hours} hours, ${remainingMinutes} minutes ago`;
                } else {
                    const days = Math.floor(timeDifference / 86400);
                    return `${days} days ago`;
                }
            } else {
                if (timeDifference < 60) {
                    return 'Beberapa detik yang lalu';
                } else if (timeDifference < 3600) {
                    const minutes = Math.floor(timeDifference / 60);
                    return `${minutes} menit yang lalu`;
                } else if (timeDifference < 86400) {
                    const hours = Math.floor(timeDifference / 3600);
                    const remainingMinutes = Math.floor((timeDifference % 3600) / 60);
                    return `${hours} jam, ${remainingMinutes} menit yang lalu`;
                } else {
                    const days = Math.floor(timeDifference / 86400);
                    return `${days} hari yang lalu`;
                }
            }
        },
        post() {
          this.$api.post('comment', this.submit)
          .then(response => {
              this.success = response.data.success
              this.submit.name = '';
              this.submit.comment = '';
              this.submit.confirmation = '';
              this.submit.request_songs = '';
              this.submit.artist = '';
              this.snackbar = true;
              setTimeout(()=>{ this.snackbar=false; }, 3000);
              this.$api.get('comment/' + this.client.id)
                  .then(response => {
                      this.hopes = response.data.data;
                  })
          })
          .catch(error => {
              if (error.response.status === 401) {
                  this.errors = error.response.data.errors;
              }
          });
        },
    },
    watch: {
      gallery(newVal) {
        this.pages = newVal.length;
      },
      showGallery(newVal) {
        if (newVal && !this.autoScrollInterval) {
          this.startAutoScroll();
        } else if (!newVal && this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
          this.autoScrollInterval = null;
        }
      },
    },
  };
</script>

<style scoped>
  .custom-background {
    background-color: #eee;
  }

  .custom-slideshow-container {
    width: 100%;
    height: 100vh; /* atau sesuai kebutuhan */
    background-repeat: no-repeat;
  }

  /* Gaya untuk ikon kaca pembesar */
  .magnifier-icon {
    position: absolute;
    bottom: 5px;
    right: 5px;
    background-color: rgba(0, 0, 0, 0.5); /* Latar belakang semi-transparan */
    color: white;
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 0.8em;
    cursor: pointer;
  }

  .gallery-item {
    width: 150px;
    height: 200px;
    margin: 10px;
    position: relative;
  }

  .gallery-item-story {
    width: 129px;
    height: 129px;
    margin-right: 6px;
    position: relative;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
  }

  .gallery-image-story {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  .elementor-image-carousel-wrapper {
    overflow: hidden;
    position: relative;
  }

  .elementor-image-carousel {
    display: flex;
    flex-wrap: nowrap;
  }

  nav > button {
    border-radius: 0.5rem;
    border: none;
    outline: none;
    margin: 0.25rem;
    padding: 1px 10px 1px 10px;
  }

  nav > button.active {
    color: #ffffff;
    border-color: #ffffff;
    background-image: linear-gradient(150deg, #c28846 0%, #8f5716 100%);
  }

  nav > button.inactive {
    color: #ffffff;
    border-color: #ffffff;
    background-image: linear-gradient(150deg, #c28846 0%, #e5b988 100%);
  }

  nav > button:focus {
    outline: none;
  }

  nav > button > svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: currentColor;
  }

  .responsive-media {
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  /* Label dan nilai agar kontras & enak dibaca */
.elementor .ui-label {
  display: inline-block;
  font-weight: 600;
  color: #444;
  letter-spacing: .2px;
}

.elementor .ui-value {
  display: inline-block;
  margin-top: .25rem;
  padding: .35rem .5rem;
  background: #f5f7fa;
  color: #222;
  border-radius: 6px;
  line-height: 1.4;
  box-shadow: 0 0 0 1px rgba(0,0,0,.04) inset;
}

/* Sedikit spacing antar-bagian dalam card alamat/penerima */
.elementor h2[data-field="penerima"],
.elementor h2[data-field="alamat"] {
  margin-bottom: .5rem;
}

/* snackbar */
#snackbar {
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 99;
  left: 49%;
  bottom: 30px;
  border-color: #333;
  font-size: 12px;
}

@media only screen and (max-width: 600px) {
  #snackbar {
    min-width: 200px;
    margin-left: -100px;
    left: 40%;
  }
}

.slide-fade-enter-active {
  transition: all .8s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(30px);
  opacity: 0;
}
</style>
